{
  "common": {
    "loading": "読み込み中...",
    "error": "エラー",
    "retry": "再試行",
    "cancel": "キャンセル",
    "save": "保存",
    "saving": "保存中...",
    "close": "閉じる",
    "back": "戻る",
    "next": "次へ",
    "search": "検索",
    "watchNow": "[ja] Watch Now",
    "playNow": "[ja] Play Now",
    "play": "再生",
    "moreInfo": "[ja] More Info",
    "seeAll": "すべて見る",
    "new": "新着",
    "live": "ライブ",
    "recommended": "おすすめ",
    "edit": "編集",
    "delete": "削除",
    "add": "追加",
    "enabled": "有効",
    "disabled": "無効",
    "invalidDate": "[ja] Invalid Date",
    "appName": "[ja] 🏠 Bayit+",
    "appVersion": "[ja] 🏠 Bayit+ v1.0.0",
    "slogan": "[ja] Your Home. Anywhere.",
    "ok": "OK",
    "success": "成功",
    "warning": "警告",
    "confirm": "確認",
    "yes": "はい",
    "no": "いいえ",
    "apply": "適用",
    "errors": {
      "unexpected": "[ja] An unexpected error occurred"
    },
    "send": "送信",
    "done": "完了",
    "all": "すべて",
    "reset": "リセット",
    "deleting": "削除中...",
    "noResults": "結果がありません",
    "tryDifferentSearch": "[ja] Try a different search term",
    "previous": "前へ",
    "actions": "[ja] Actions",
    "pageOf": "[ja] Page {{page}} of {{total}}",
    "noData": "データがありません",
    "filters": "[ja] Filters",
    "clear": "クリア",
    "clearSelection": "[ja] Clear",
    "expand": "展開",
    "collapse": "折りたたむ",
    "upgrade": "アップグレード",
    "skip": "スキップ",
    "thisContent": "[ja] this content",
    "backToHome": "[ja] Back to Home",
    "dismiss": "[ja] Dismiss",
    "goBack": "[ja] Go Back",
    "pause": "[ja] Pause",
    "tryAgain": "[ja] Try Again",
    "refresh": "更新"
  },
  "culturalContext": {
    "loading": "説明を読み込み中...",
    "loadError": "説明の読み込みに失敗しました",
    "related": "関連する参照"
  },
  "demo": {
    "banner": "[ja] DEMO MODE",
    "bannerSubtext": "[ja] Using mock data - No API calls",
    "days": {
      "sunday": "[ja] Sunday",
      "monday": "[ja] Monday",
      "tuesday": "[ja] Tuesday",
      "wednesday": "[ja] Wednesday",
      "thursday": "[ja] Thursday",
      "friday": "[ja] Friday",
      "saturday": "[ja] Saturday"
    },
    "shabbat": "[ja] Shabbat",
    "until_shabbat": "[ja] Until Shabbat",
    "search_interpretation": "[ja] Search for \"{{query}}\"",
    "suggestions": {
      "0": "[ja] Fauda",
      "1": "[ja] Shtisel",
      "2": "[ja] Tehran",
      "3": "[ja] The Arbitrator",
      "4": "[ja] Labour"
    },
    "premium_plan": "[ja] Premium",
    "assistant_response": "[ja] I recommend Fauda - an excellent thriller series!",
    "morning_greeting": "[ja] Good morning! Today the weather is nice, there are some important news from Israel, and I've selected content especially for you."
  },
  "hero": {
    "watch": "[ja] Watch",
    "moreInfo": "[ja] More Info",
    "addToList": "[ja] Add to List"
  },
  "login": {
    "title": "ログイン",
    "subtitle": "アカウントにログイン",
    "tagline": "[ja] Your Home in the USA",
    "email": "メールアドレス",
    "emailPlaceholder": "メールアドレスを入力",
    "password": "パスワード",
    "passwordPlaceholder": "パスワードを入力",
    "submit": "[ja] Sign In",
    "loggingIn": "[ja] Signing in...",
    "or": "[ja] or",
    "forgotPassword": "パスワードをお忘れですか？",
    "continueWithGoogle": "[ja] Continue with Google",
    "noAccount": "アカウントをお持ちでないですか？",
    "signUp": "[ja] Sign Up",
    "register": "[ja] Register",
    "name": "[ja] Name",
    "termsNotice": "[ja] By signing in, you agree to our Terms of Service and Privacy Policy",
    "errors": {
      "emailRequired": "[ja] Email is required",
      "passwordRequired": "[ja] Password is required",
      "loginFailed": "[ja] Login failed. Please check your credentials.",
      "googleFailed": "[ja] Google sign-in failed. Please try again.",
      "fillAllFields": "[ja] Please fill in all fields"
    },
    "qrInstructions": "[ja] Scan the code with your phone for quick login",
    "methodQR": "[ja] QR Code",
    "methodVoice": "[ja] Voice",
    "methodTraditional": "[ja] Email",
    "qrTitle": "[ja] Scan to Login",
    "qrDescription": "[ja] Scan this QR code with your phone to login without typing",
    "expiresIn": "[ja] Expires in 5 minutes",
    "companionConnected": "[ja] Phone connected!",
    "authenticating": "[ja] Logging you in...",
    "sessionExpired": "セッションが期限切れです。再度ログインしてください",
    "refreshQR": "[ja] Generate New Code",
    "generatingQR": "[ja] Generating QR code...",
    "howItWorks": "[ja] How it works:",
    "step1": "[ja] Open camera on your phone",
    "step2": "[ja] Scan the QR code above",
    "step3": "[ja] Login on your phone",
    "step4": "[ja] TV logs in automatically!",
    "voicePlaceholder": "[ja] Type your response...",
    "send": "[ja] Send",
    "createAccount": "アカウントを作成",
    "bayitThinking": "[ja] Bayit is thinking...",
    "unexpectedError": "[ja] An unexpected error occurred"
  },
  "tvLogin": {
    "invalidQR": "[ja] Invalid QR code. Please scan again from your TV.",
    "sessionInvalid": "[ja] This QR code has expired. Please generate a new one on your TV.",
    "verificationFailed": "[ja] Failed to verify session. Please try again.",
    "fillAllFields": "[ja] Please fill in all fields",
    "loginFailed": "[ja] Login failed. Please check your credentials.",
    "notLoggedIn": "[ja] You are not logged in on this device.",
    "enterCredentials": "[ja] Please enter your credentials to authorize your TV.",
    "authFailed": "[ja] Authorization failed.",
    "verifying": "[ja] Verifying...",
    "verifyingDescription": "[ja] Connecting to your TV...",
    "loginTitle": "[ja] Login to Your TV",
    "loginDescription": "[ja] Enter your credentials to authorize your TV",
    "authorizing": "[ja] Authorizing...",
    "authorizingDescription": "[ja] Logging you in on your TV...",
    "authorizeTV": "[ja] Authorize TV",
    "success": "[ja] Success!",
    "successDescription": "[ja] Your TV is now logged in. You can close this page.",
    "goToHome": "[ja] Go to Home",
    "error": "[ja] Something went wrong",
    "tryAgain": "[ja] Try Again",
    "securityNote": "[ja] Your credentials are sent securely and are never stored on the TV.",
    "footer": "[ja] Having trouble? Make sure you scanned a fresh QR code from your TV.",
    "almostThere": "[ja] Almost there!",
    "authenticating": "[ja] Authenticating...",
    "connected": "[ja] Connected",
    "expired": "[ja] Code Expired",
    "expiredMessage": "[ja] Your sign-in code has expired. Please request a new one.",
    "header": "[ja] Sign In to TV",
    "pleaseSignIn": "[ja] Please sign in on your phone or computer",
    "signInButton": "[ja] Sign In",
    "signInToTV": "[ja] Sign In to TV",
    "subtitle": "[ja] Enter the code shown on your TV screen",
    "tvSignedIn": "[ja] TV signed in successfully"
  },
  "googleLogin": {
    "cancelledError": "[ja] Google sign-in was cancelled",
    "missingCode": "[ja] Authentication code is missing",
    "loginError": "[ja] Error signing in with Google",
    "redirecting": "[ja] Redirecting to login page...",
    "connecting": "[ja] Connecting with Google..."
  },
  "register": {
    "title": "アカウント作成",
    "subtitle": "Bayit+に参加",
    "name": "氏名",
    "namePlaceholder": "山田太郎",
    "email": "メールアドレス",
    "emailPlaceholder": "your@email.com",
    "password": "パスワード",
    "passwordPlaceholder": "8文字以上",
    "confirmPassword": "パスワードを確認",
    "confirmPasswordPlaceholder": "パスワードを再入力",
    "submit": "[ja] Sign Up",
    "registering": "[ja] Signing up...",
    "acceptTerms": "[ja] I agree to the",
    "termsOfService": "[ja] Terms of Service",
    "and": "と",
    "privacyPolicy": "プライバシーポリシー",
    "continueWithGoogle": "[ja] Sign up with Google",
    "haveAccount": "すでにアカウントをお持ちですか？",
    "signIn": "ログイン",
    "fullName": "[ja] Full Name",
    "loginLink": "[ja] Login",
    "placeholders": {
      "fullName": "[ja] John Doe",
      "email": "[ja] your@email.com",
      "password": "[ja] At least 8 characters",
      "confirmPassword": "[ja] Enter password again"
    },
    "errors": {
      "nameRequired": "[ja] Name is required",
      "emailRequired": "[ja] Email is required",
      "passwordRequired": "[ja] Password is required",
      "passwordTooShort": "[ja] Password must be at least 8 characters",
      "passwordMismatch": "[ja] Passwords do not match",
      "acceptTerms": "[ja] You must accept the Terms of Service and Privacy Policy",
      "fillAllFields": "[ja] Please fill in all fields",
      "registrationFailed": "[ja] Registration failed. Please try again.",
      "googleFailed": "[ja] Sign up with Google failed. Please try again."
    }
  },
  "nav": {
    "home": "ホーム",
    "vod": "ビデオオンデマンド",
    "liveTV": "ライブTV",
    "epg": "番組表",
    "radio": "ラジオ",
    "podcasts": "ポッドキャスト",
    "flows": "[ja] Flows",
    "judaism": "[ja] Judaism",
    "children": "[ja] Kids",
    "profile": "プロフィール",
    "search": "検索",
    "settings": "設定",
    "favorites": "お気に入り",
    "watchlist": "ウォッチリスト",
    "downloads": "ダウンロード",
    "recordings": "録画",
    "widgets": "[ja] Widgets",
    "help": "ヘルプ",
    "discover": "発見",
    "account": "アカウント",
    "subscribe": "[ja] Subscribe",
    "plans": "[ja] Plans",
    "admin": "[ja] Admin",
    "games": "ゲーム",
    "friends": "フレンド",
    "glossary": "用語集",
    "missions": "ミッション",
    "audiobooks": "オーディオブック",
    "playlist": "プレイリスト",
    "zehAniHub": "ゼ・アニ",
    "support": "サポート",
    "discoverHub": "AIを発見",
    "listen": "聴く",
    "byoc": "マイソース",
    "household": "世帯",
    "messages": "メッセージ",
    "myContent": "マイコンテンツ",
    "social": "ソーシャル"
  },
  "epg": {
    "title": "番組表",
    "subtitle": "番組ガイド",
    "gridView": "[ja] Grid View",
    "listView": "[ja] List View",
    "israelTime": "[ja] Israel Time",
    "localTime": "[ja] Local Time",
    "il": "[ja] IL",
    "local": "[ja] Local",
    "jumpToNow": "[ja] Jump to Now",
    "goBack": "[ja] ← {{hours}}h",
    "goForward": "[ja] {{hours}}h →",
    "toggleTimezone": "[ja] Toggle Timezone",
    "errorTitle": "[ja] Failed to Load TV Guide",
    "errorLoading": "[ja] Could not load TV guide data",
    "noPrograms": "番組がありません",
    "noChannels": "[ja] No channels available",
    "recordProgram": "[ja] Record Program",
    "channel": "[ja] Channel",
    "enableSubtitles": "[ja] Enable Subtitles",
    "subtitleLanguage": "[ja] Subtitle Language",
    "storageEstimate": "[ja] Storage Estimate",
    "availableSpace": "[ja] Available Space",
    "lowStorage": "[ja] Low Storage Warning",
    "lowStorageMessage": "[ja] You're running low on storage space. Consider deleting old recordings.",
    "scheduleRecording": "[ja] Schedule Recording",
    "scheduledRecordingNotSupported": "[ja] Scheduled recordings are not yet supported. Only immediate recordings are available.",
    "recordingFailed": "[ja] Failed to start/schedule recording",
    "smartSearch": "[ja] Smart Search",
    "smartSearchSubtitle": "[ja] Ask questions in natural language",
    "smartSearchPlaceholder": "[ja] e.g., Show me all shows with actress Tali Sharon tonight",
    "searchPlaceholder": "[ja] Search programs, channels, actors...",
    "premiumRequired": "[ja] Premium Feature",
    "premiumRequiredMessage": "[ja] Smart Search uses AI to understand your questions. Upgrade to Premium to access this feature.",
    "searchWithAI": "[ja] Search with AI",
    "searching": "[ja] Searching...",
    "tryThese": "[ja] Try these examples",
    "exampleQuery1": "[ja] Show me all shows with actress Tali Sharon tonight",
    "exampleQuery2": "[ja] What comedy shows are airing this week?",
    "exampleQuery3": "[ja] Find documentaries about history on Channel 11",
    "exampleQuery4": "[ja] Show me all news programs tomorrow morning",
    "aiDisclaimer": "[ja] Powered by Claude AI. Results may vary based on program data availability.",
    "interpretationTitle": "[ja] What I understood",
    "noResultsFound": "[ja] No programs found matching your query"
  },
  "home": {
    "continueWatching": "視聴を続ける",
    "featuredContent": "[ja] Featured",
    "liveTV": "[ja] Live TV",
    "allChannels": "[ja] All Channels",
    "liveChannels": "[ja] Live Channels",
    "showOnlyWithSubtitles": "[ja] Show only with subtitles",
    "israeliMovies": "[ja] Israeli Movies",
    "israeli-movies": "[ja] Israeli Movies",
    "israeli-series": "[ja] Israeli Series",
    "action": "[ja] Action & Thriller",
    "comedy": "[ja] Comedy",
    "drama": "[ja] Drama",
    "documentaries": "[ja] Documentaries",
    "loadingContent": "[ja] Loading content...",
    "liveNow": "現在ライブ",
    "trendingInIsrael": "[ja] Trending in Israel",
    "jerusalemConnection": "[ja] Jerusalem Connection",
    "telAvivConnection": "[ja] Tel Aviv Connection",
    "categories": "[ja] Categories",
    "nearYou": "近くのイスラエル人",
    "betaExclusive": "ベータ限定",
    "carousel": {
      "fauda": {
        "title": "[ja] Fauda",
        "subtitle": "[ja] Season 4 - Now Streaming",
        "description": "[ja] The hit Israeli series returns for a fourth season full of suspense and action"
      },
      "shtisel": {
        "title": "[ja] Shtisel",
        "subtitle": "[ja] All Seasons Available",
        "description": "[ja] Follow the Shtisel family in the ultra-Orthodox neighborhood of Jerusalem"
      },
      "tehran": {
        "title": "[ja] Tehran",
        "subtitle": "[ja] Season 2",
        "description": "[ja] A Mossad agent deep in Iran on a dangerous mission"
      },
      "live": {
        "title": "[ja] Live - Kan 11",
        "subtitle": "[ja] Watch Now",
        "description": "[ja] News, current affairs and quality content"
      }
    },
    "enableLocation": "[ja] Enable Location",
    "locationPermissionDeniedDescription": "[ja] Location access was denied. Enable it in Settings to see content near you.",
    "locationPermissionDescription": "[ja] Allow location access to discover content near you.",
    "openSettings": "[ja] Open Settings"
  },
  "search": {
    "title": "検索",
    "subtitle": "[ja] Find movies, series, channels, radio stations and podcasts",
    "placeholder": "検索...",
    "voicePlaceholder": "[ja] Speak now...",
    "searching": "[ja] Searching...",
    "listening": "聞いています...",
    "noResults": "結果が見つかりませんでした",
    "noResultsHint": "[ja] Try different keywords or change your filters",
    "tryDifferent": "別のキーワードをお試しください",
    "resultsFor": "の検索結果",
    "resultsFound": "[ja] {{count}} results found for \"{{query}}\"",
    "recentSearches": "最近の検索",
    "clearAll": "[ja] Clear All",
    "trending": "トレンドの検索",
    "promptTitle": "[ja] What are you looking for?",
    "promptDescription": "[ja] Search for your favorite content or use voice search",
    "filters": {
      "all": "[ja] All",
      "vod": "[ja] Movies & Series",
      "live": "[ja] Channels",
      "radio": "[ja] Radio",
      "podcast": "[ja] Podcasts",
      "moviesAndSeries": "[ja] Movies & Series",
      "channels": "[ja] Channels",
      "podcasts": "[ja] Podcasts"
    },
    "suggestions": {
      "movies": "[ja] Movies",
      "series": "[ja] Series",
      "liveTV": "[ja] Live TV",
      "news": "[ja] News",
      "sports": "[ja] Sports",
      "kids": "[ja] Kids"
    }
  },
  "liveTV": {
    "title": "ライブTV",
    "channels": "[ja] Channels",
    "nowPlaying": "現在放送中",
    "loadError": "[ja] Failed to load channels",
    "categories": {
      "all": "[ja] All",
      "news": "[ja] News",
      "sports": "[ja] Sports",
      "entertainment": "[ja] Entertainment",
      "kids": "[ja] Kids",
      "documentary": "[ja] Documentary"
    }
  },
  "listen": {
    "title": "聴く",
    "subtitle": "ラジオ、ポッドキャスト、オーディオブック",
    "tab": {
      "radio": "ラジオ",
      "podcasts": "ポッドキャスト",
      "audiobooks": "オーディオブック"
    }
  },
  "radio": {
    "title": "ラジオ",
    "categories": {
      "all": "[ja] All",
      "music": "[ja] Music",
      "news": "[ja] News",
      "talk": "[ja] Talk",
      "jewish": "[ja] Jewish"
    },
    "noStations": "[ja] No radio stations available",
    "tryLater": "[ja] Try again later",
    "playing": "再生中",
    "fmSuffix": "FM"
  },
  "podcasts": {
    "title": "ポッドキャスト",
    "episodes": "エピソード",
    "categories": {
      "all": "[ja] All",
      "general": "[ja] General",
      "news": "[ja] News",
      "politics": "[ja] Politics",
      "tech": "[ja] Tech",
      "business": "[ja] Business",
      "jewish": "[ja] Jewish",
      "entertainment": "[ja] Entertainment",
      "sports": "[ja] Sports",
      "history": "[ja] History",
      "educational": "[ja] Educational"
    },
    "noPodcasts": "[ja] No podcasts available",
    "tryLater": "[ja] Try again later",
    "playLatest": "[ja] Play Latest"
  },
  "vod": {
    "title": "ビデオオンデマンド",
    "movies": "映画",
    "series": "シリーズ",
    "searchPlaceholder": "[ja] Search movies and series...",
    "noMovies": "[ja] No movies found",
    "noSeries": "[ja] No series found",
    "loadError": "[ja] Failed to load content",
    "showOnlyWithSubtitles": "[ja] Show only with subtitles",
    "categories": {
      "all": "[ja] All",
      "drama": "[ja] Drama",
      "comedy": "[ja] Comedy",
      "action": "[ja] Action",
      "documentary": "[ja] Documentary",
      "kids": "[ja] Kids"
    },
    "allCategories": "[ja] All",
    "emptyTitle": "[ja] No Content Available",
    "emptyDescription": "[ja] Try selecting another category",
    "allContent": "すべてのコンテンツ",
    "noContent": "[ja] No content available",
    "noContentInCategory": "[ja] No content found in this category"
  },
  "account": {
    "title": "アカウント",
    "profile": "プロフィール",
    "settings": "[ja] Settings",
    "subscription": "サブスクリプション",
    "manageSubscription": "サブスクリプション管理",
    "personalDetails": "[ja] Personal Details",
    "billing": "お支払い",
    "logout": "[ja] Logout",
    "login": "[ja] Login",
    "register": "[ja] Register",
    "email": "[ja] Email",
    "password": "[ja] Password",
    "name": "[ja] Name",
    "guest": "[ja] Guest",
    "premium": "[ja] Premium",
    "basic": "[ja] Basic"
  },
  "flows": {
    "title": "[ja] Flows",
    "subtitle": "[ja] Personalized content experiences for every moment",
    "activeNow": "[ja] Active Now",
    "start": "[ja] Start",
    "skipToday": "[ja] Skip Today",
    "systemFlows": "[ja] Ready-Made Flows",
    "customFlows": "[ja] My Flows",
    "system": "[ja] System",
    "noCustomFlows": "[ja] No custom flows yet",
    "createHint": "[ja] Create your first personalized flow",
    "createCustom": "[ja] Create Custom Flow",
    "createFlow": "[ja] Create Flow",
    "editFlow": "[ja] Edit Flow",
    "type": "[ja] Type",
    "systemFlow": "[ja] System Flow",
    "customFlow": "[ja] Custom Flow",
    "schedule": "[ja] Schedule",
    "content": "[ja] Content",
    "items": "[ja] items",
    "aiGenerated": "[ja] AI Generated",
    "autoPlay": "[ja] Auto Play",
    "aiEnabled": "[ja] AI Curation",
    "shabbatTrigger": "[ja] Shabbat Evening",
    "manual": "[ja] Manual",
    "flowName": "[ja] Flow Name",
    "flowNamePlaceholder": "[ja] e.g., My Morning Routine",
    "description": "[ja] Description",
    "descriptionPlaceholder": "[ja] What is this flow for?",
    "startTime": "[ja] Start Time",
    "endTime": "[ja] End Time",
    "actions": "[ja] Actions",
    "details": "[ja] Details",
    "createFlowDesc": "[ja] Design your personalized content experience",
    "editFlowDesc": "[ja] Update your flow settings and content",
    "basicInfo": "[ja] Basic Information",
    "options": "[ja] Options",
    "autoPlayDesc": "[ja] Automatically play next item when current one ends",
    "aiEnabledDesc": "[ja] Let AI curate content based on your preferences",
    "startFlow": "[ja] Start Flow",
    "deleteFlow": "[ja] Delete Flow",
    "custom": "[ja] Custom",
    "morning": "[ja] Morning",
    "evening": "[ja] Evening",
    "shabbat": "[ja] Shabbat",
    "addContent": "[ja] Add Content",
    "contentPicker": {
      "title": "[ja] Add Content to Flow",
      "tabs": {
        "live": "[ja] Live TV",
        "radio": "[ja] Radio",
        "vod": "[ja] On Demand",
        "podcast": "[ja] Podcasts"
      },
      "search": "[ja] Search content...",
      "selected": "[ja] {{count}} selected",
      "addSelected": "[ja] Add Selected",
      "noResults": "[ja] No content found",
      "alreadyAdded": "[ja] Already in flow",
      "loadMore": "[ja] Load More"
    },
    "flowItems": {
      "title": "[ja] Flow Content",
      "empty": "[ja] No content yet. Click Add Content to get started.",
      "count": "[ja] {{count}} items",
      "remove": "[ja] Remove",
      "moveUp": "[ja] Move Up",
      "moveDown": "[ja] Move Down",
      "order": "[ja] Order",
      "confirmRemove": "[ja] Click again to confirm removal",
      "maxReached": "[ja] Maximum {{max}} items reached",
      "more": "[ja] more items"
    },
    "days": {
      "sunday": "[ja] Sunday",
      "monday": "[ja] Monday",
      "tuesday": "[ja] Tuesday",
      "wednesday": "[ja] Wednesday",
      "thursday": "[ja] Thursday",
      "friday": "[ja] Friday",
      "saturday": "[ja] Saturday",
      "sundayShort": "[ja] Sun",
      "mondayShort": "[ja] Mon",
      "tuesdayShort": "[ja] Tue",
      "wednesdayShort": "[ja] Wed",
      "thursdayShort": "[ja] Thu",
      "fridayShort": "[ja] Fri",
      "saturdayShort": "[ja] Sat",
      "selectAll": "[ja] Select All",
      "deselectAll": "[ja] Deselect All",
      "title": "[ja] Active Days",
      "everyday": "[ja] Every day",
      "everyDay": "[ja] Every day",
      "weekdays": "[ja] Weekdays",
      "weekends": "[ja] Weekends",
      "noneSelected": "[ja] No days selected",
      "selectedCount": "[ja] {{count}} days selected"
    },
    "trigger": {
      "type": "[ja] Trigger Type",
      "time": "[ja] Time-based",
      "shabbat": "[ja] Shabbat Evening",
      "holiday": "[ja] Holiday",
      "skipShabbat": "[ja] Skip on Shabbat",
      "skipShabbatDesc": "[ja] Don't run this flow on Friday evening or Saturday",
      "shabbatOffset": "[ja] Minutes before candle lighting",
      "shabbatOffsetDesc": "[ja] How many minutes before Shabbat should this flow start?",
      "calculatedTime": "[ja] Calculated time",
      "thisWeek": "[ja] This week: {{day}} at {{time}}",
      "comingSoon": "[ja] Holiday triggers coming soon",
      "locationBased": "[ja] Times based on your location"
    },
    "examples": {
      "title": "[ja] Example Flows",
      "subtitle": "[ja] Tap to use as a template",
      "morningRoutine": {
        "name": "[ja] Morning Routine",
        "desc": "[ja] Start your day with news, weather, and uplifting content"
      },
      "eveningWindDown": {
        "name": "[ja] Evening Wind Down",
        "desc": "[ja] Relax with calming music and light entertainment"
      },
      "shabbatPrep": {
        "name": "[ja] Shabbat Preparation",
        "desc": "[ja] Set the mood for Shabbat with special content"
      },
      "coffeeBreak": {
        "name": "[ja] Coffee Break",
        "desc": "[ja] Quick entertainment for a short break"
      },
      "sunsetVibes": {
        "name": "[ja] Sunset Vibes",
        "desc": "[ja] Weekend relaxation with music and ambient content"
      }
    },
    "aiBrief": "[ja] AI Brief",
    "aiBriefDesc": "[ja] Get a personalized AI-generated summary before the flow starts",
    "aiBriefEnabled": "[ja] AI Brief Enabled",
    "validation": {
      "nameRequired": "[ja] Flow name is required",
      "startTimeRequired": "[ja] Start time is required",
      "endTimeRequired": "[ja] End time is required",
      "timeRange": "[ja] End time must be after start time",
      "daysRequired": "[ja] Select at least one day",
      "contentRequired": "[ja] Add content or enable AI"
    },
    "tv": {
      "useCompanion": "[ja] For full customization, use the Bayit+ app on your phone or visit bayit.plus on your computer."
    }
  },
  "profile": {
    "title": "プロフィール",
    "profileDetails": "[ja] Profile Details",
    "name": "[ja] Name",
    "notSet": "[ja] Not set",
    "email": "[ja] Email",
    "editProfile": "プロフィールを編集",
    "notificationSettings": "[ja] Notification Settings",
    "security": "[ja] Security",
    "changePassword": "[ja] Change Password",
    "updatePassword": "[ja] Update your password",
    "connectedDevices": "[ja] Connected Devices",
    "manageDevices": "[ja] Manage devices connected to your account",
    "twoFactorAuth": "[ja] Two-Factor Authentication",
    "addExtraSecurity": "[ja] Add an extra layer of security",
    "address": {
      "line1": "[ja] 123 Main Street",
      "line2": "[ja] Tel Aviv, Israel 6100000"
    },
    "free": "[ja] Free",
    "premiumPrice": "[ja] $7.99/month",
    "familyPrice": "[ja] $12.99/month",
    "remaining": "[ja] remaining",
    "tabs": {
      "personal": "[ja] Personal",
      "overview": "[ja] Overview",
      "subscription": "[ja] Subscription",
      "notifications": "[ja] Notifications",
      "security": "[ja] Security",
      "ai": "[ja] AI & Voice",
      "voice": "[ja] Voice & Accessibility"
    },
    "subscription": {
      "currentPlan": "[ja] Current Plan",
      "renewsOn": "[ja] Renews on",
      "manageSubscription": "[ja] Manage Subscription",
      "cancelSubscription": "[ja] Cancel Subscription",
      "noActivePlan": "[ja] No active subscription",
      "selectPlan": "[ja] Select a Plan"
    },
    "notifications": "[ja] Notifications",
    "ai": {
      "title": "[ja] AI & Personalization",
      "description": "[ja] Configure AI-powered features",
      "assistant": "[ja] AI Assistant",
      "assistantDesc": "[ja] Personalized recommendations and help",
      "chatbot": "[ja] AI Assistant",
      "chatbotEnabled": "[ja] Enable AI Assistant",
      "chatbotEnabledDesc": "[ja] Get help navigating content",
      "saveHistory": "[ja] Save Conversation History",
      "saveHistoryDesc": "[ja] Remember previous conversations",
      "recommendations": "[ja] Recommendations",
      "personalizedRecs": "[ja] Personalized Recommendations",
      "personalizedRecsDesc": "[ja] Content suggestions based on history",
      "privacy": "[ja] Privacy & Data",
      "privacyDesc": "[ja] Your data is encrypted and secure",
      "dataConsent": "[ja] Usage Analytics",
      "dataConsentDesc": "[ja] Help improve AI features",
      "privacyNote": "[ja] Your data is encrypted and secure"
    },
    "voice": {
      "title": "[ja] Voice Control",
      "description": "[ja] Hands-free navigation",
      "enabled": "[ja] Voice Commands",
      "enabledDesc": "[ja] Control the app with your voice",
      "tts": "[ja] Text-to-Speech",
      "ttsDesc": "[ja] AI responses read aloud",
      "wakeWord": "[ja] Wake Word Detection",
      "wakeWordDesc": "[ja] Say \"Bayit\" to activate",
      "operationMode": "[ja] Operation Mode",
      "operationModeDesc": "[ja] Choose how you interact with the app",
      "voiceSearch": "[ja] Voice Search",
      "voiceSearchEnabled": "[ja] Enable voice search",
      "voiceSearchEnabledDesc": "[ja] Search for content using your voice",
      "constantListening": "[ja] Always Listening Mode",
      "constantListeningDesc": "[ja] Continuously listen for voice commands without pressing a button",
      "constantListeningPrivacy": "[ja] Audio is only sent to servers when speech is detected",
      "holdButtonMode": "[ja] Hold Button to Talk",
      "holdButtonModeDesc": "[ja] Press and hold the microphone button instead of always listening",
      "sensitivity": "[ja] Voice Detection Sensitivity",
      "sensitivityDesc": "[ja] Adjust how responsive the voice detection is",
      "sensitivityLow": "[ja] Low (fewer false triggers)",
      "sensitivityMedium": "[ja] Medium (balanced)",
      "sensitivityHigh": "[ja] High (most responsive)",
      "silenceThreshold": "[ja] Silence Detection",
      "silenceThresholdDesc": "[ja] How long to wait after speaking before processing",
      "language": "[ja] Voice language",
      "accessibility": "[ja] Accessibility",
      "autoSubtitle": "[ja] Auto-enable subtitles",
      "autoSubtitleDesc": "[ja] Automatically show subtitles when playing content",
      "highContrast": "[ja] High contrast mode",
      "highContrastDesc": "[ja] Increase contrast for better visibility",
      "textSize": "[ja] Text size",
      "textSizeSmall": "[ja] Small",
      "textSizeMedium": "[ja] Medium",
      "textSizeLarge": "[ja] Large",
      "voiceOnlyInfo": "[ja] Voice Only Mode",
      "voiceOnlyDetails": "[ja] Say \"Hi Bayit\" to activate. Remote control disabled. Navigate entirely with voice commands.",
      "hybridInfo": "[ja] Hybrid Mode",
      "hybridDetails": "[ja] Use voice or remote control. Voice feedback on non-voice actions.",
      "classicInfo": "[ja] Classic Mode",
      "classicDetails": "[ja] All voice features disabled. Remote control only.",
      "textToSpeech": "[ja] Voice Responses",
      "ttsEnabled": "[ja] Enable voice responses",
      "ttsEnabledDesc": "[ja] App will speak responses to your voice commands",
      "ttsVolume": "[ja] Voice Volume",
      "ttsSpeed": "[ja] Speaking Speed",
      "hybridFeedback": "[ja] Interactive Feedback",
      "voiceFeedback": "[ja] Voice feedback on actions",
      "voiceFeedbackDesc": "[ja] Get voice confirmation when you use the remote or click buttons",
      "feedbackExample": "[ja] Example: Click a movie → App says \"Playing [Movie Name]\""
    },
    "dropdown": {
      "myProfile": "[ja] My Profile",
      "subscription": "[ja] Subscription",
      "favorites": "[ja] Favorites",
      "downloads": "[ja] Downloads",
      "signOut": "[ja] Sign Out"
    },
    "guest": "[ja] Guest",
    "morningRitual": "[ja] Morning Ritual",
    "watchlist": "[ja] Watchlist",
    "favorites": "[ja] Favorites",
    "downloads": "[ja] Downloads",
    "settings": "[ja] Settings",
    "language": "言語",
    "admin": "[ja] Admin",
    "watchTime": "[ja] Watch Time",
    "minutes": "[ja] minutes",
    "hours": "[ja] hours",
    "logout": "[ja] Log Out",
    "premium": "[ja] Premium",
    "basic": "[ja] Basic",
    "upgrade": "[ja] Upgrade to Premium",
    "memberSince": "[ja] Member since",
    "aiAssistant": "[ja] AI Assistant",
    "voiceSettings": "[ja] Voice",
    "subscriptionButton": "[ja] Subscription",
    "recentActivity": "[ja] Recent Activity",
    "justNow": "[ja] Just now",
    "hoursAgo": "[ja] {{hours}} hours ago",
    "yesterday": "[ja] Yesterday",
    "noRecentActivity": "[ja] No recent activity",
    "accountInfo": "[ja] Account Information",
    "role": "[ja] Role",
    "accountSecurity": "[ja] Account Security",
    "securityNote": "[ja] Your account is secured with encrypted authentication",
    "lastLogin": "[ja] Last login",
    "dangerZone": "[ja] Danger Zone",
    "invalidImageType": "[ja] Please select a valid image file (JPEG, PNG, WebP, or GIF)",
    "imageTooLarge": "[ja] Image is too large. Maximum size is 5MB.",
    "uploadSuccess": "[ja] Avatar updated successfully!",
    "uploadFailed": "[ja] Failed to upload avatar. Please try again.",
    "complimentaryPremium": "無料プレミアムアクセス",
    "emailVerified": "メール認証済み",
    "emailUnverified": "メール未認証",
    "phoneVerified": "電話認証済み",
    "phoneUnverified": "電話未認証",
    "completeVerification": "すべての機能をアンロックするには認証を完了してください",
    "unlockPremium": "プレミアム機能をアンロック",
    "unlockPremiumDescription": "限定コンテンツと機能を楽しむためにアップグレード"
  },
  "voiceMode": {
    "voiceOnly": "[ja] Voice Only",
    "voiceOnlyDesc": "[ja] No remote control - full voice navigation",
    "hybrid": "[ja] Hybrid",
    "hybridDesc": "[ja] Voice + Remote - voice feedback on actions",
    "classic": "[ja] Classic",
    "classicDesc": "[ja] No voice - remote control only"
  },
  "settings": {
    "title": "設定",
    "language": "言語",
    "appLanguage": "[ja] App Language",
    "selectLanguage": "[ja] Select Language",
    "languages": {
      "en": "[ja] English",
      "he": "[ja] עברית",
      "es": "[ja] Español",
      "zh": "[ja] 中文",
      "fr": "[ja] Français",
      "it": "[ja] Italiano",
      "hi": "[ja] हिन्दी",
      "ta": "[ja] தமிழ்",
      "bn": "[ja] বাংলা",
      "ja": "[ja] 日本語"
    },
    "chatTranslation": "[ja] Chat Translation",
    "autoTranslate": "[ja] Auto-translate messages",
    "autoTranslateDescription": "[ja] Automatically translate chat messages to your preferred language",
    "notifications": "通知",
    "pushNotifications": "プッシュ通知",
    "playback": "再生",
    "quality": "[ja] Quality",
    "subtitles": "字幕",
    "autoplay": "[ja] Autoplay",
    "appearance": "外観",
    "darkMode": "ダークモード",
    "privacy": "プライバシー",
    "privacyPolicy": "プライバシーポリシー",
    "termsOfService": "利用規約",
    "about": "概要",
    "display": "[ja] Display",
    "homePageSections": "[ja] Home Page Sections",
    "configureSections": "[ja] Configure which sections appear on your home page",
    "visibleSections": "[ja] Visible Sections",
    "hiddenSections": "[ja] Hidden Sections",
    "dragToReorder": "[ja] Drag to reorder",
    "tapToHide": "[ja] Tap to hide",
    "tapToShow": "[ja] Tap to show",
    "resetToDefault": "[ja] Reset to Default",
    "resetConfirmMessage": "[ja] Are you sure you want to reset home page sections to their default configuration?",
    "sectionHidden": "[ja] Section hidden",
    "sectionShown": "[ja] Section shown",
    "replayTour": "機能ツアーをもう一度見る"
  },
  "help": {
    "subtitle": "[ja] How can we help you?",
    "email": "[ja] Email Support",
    "phone": "[ja] Phone Support",
    "chat": "[ja] Live Chat",
    "chatAvailable": "[ja] Available 24/7",
    "openTooltip": "[ja] Open help tooltip",
    "openHelp": "[ja] Open help menu",
    "howTo": "[ja] How to use",
    "relatedArticles": "[ja] Related articles",
    "stillNeedHelp": "[ja] Still need help?",
    "contactSupport": "[ja] Contact Support",
    "previous": "[ja] Previous",
    "next": "[ja] Next",
    "getStarted": "[ja] Get Started",
    "skipTutorial": "[ja] Skip tutorial",
    "actions": {
      "search": "[ja] Search Help",
      "docs": "[ja] Documentation",
      "faq": "[ja] FAQ",
      "support": "[ja] Contact Support",
      "tutorial": "[ja] View Tutorial"
    },
    "search": {
      "placeholder": "[ja] Search help...",
      "noResults": "[ja] No results found for \"{{query}}\"",
      "noResultsHint": "[ja] Try different keywords or browse categories",
      "recent": "[ja] Recent",
      "popular": "[ja] Popular"
    },
    "categories": {
      "getting-started": "[ja] Getting Started",
      "features": "[ja] Features",
      "judaism": "[ja] Judaism",
      "platform-guides": "[ja] Platform Guides",
      "account": "[ja] Account",
      "troubleshooting": "[ja] Troubleshooting",
      "parents": "[ja] For Parents",
      "admin": "[ja] Admin Guide",
      "developer": "[ja] Developer API"
    },
    "faq": {
      "title": "[ja] Frequently Asked Questions",
      "q1": "[ja] How do I change my subscription plan?",
      "a1": "[ja] Go to Settings > Subscription to view and change your current plan. You can upgrade or downgrade at any time.",
      "q2": "[ja] How do I download content for offline viewing?",
      "a2": "[ja] Tap the download icon on any content to save it for offline viewing. Downloads are available on mobile devices only.",
      "q3": "[ja] Why isn't my video playing?",
      "a3": "[ja] Check your internet connection. If the problem persists, try clearing the app cache or restarting the app.",
      "q4": "[ja] How do I cancel my subscription?",
      "a4": "[ja] You can cancel your subscription anytime through Settings > Subscription > Cancel Plan. You'll continue to have access until the end of your billing period."
    },
    "onboarding": {
      "welcome": {
        "title": "[ja] Welcome to Bayit+",
        "description": "[ja] Your home for Israeli entertainment, anywhere in the world"
      },
      "liveTv": {
        "title": "[ja] Live TV",
        "description": "[ja] Watch Israeli channels live, including news, sports, and entertainment"
      },
      "vod": {
        "title": "[ja] On-Demand Content",
        "description": "[ja] Browse movies, series, and documentaries anytime"
      },
      "voice": {
        "title": "[ja] Voice Control",
        "description": "[ja] Say 'Bayit' to control the app with your voice"
      },
      "profiles": {
        "title": "[ja] Family Profiles",
        "description": "[ja] Create profiles for each family member with personalized recommendations"
      }
    }
  },
  "voice": {
    "panelTitle": "音声アシスタント",
    "typeCommand": "コマンドを入力してください...",
    "controlExecuted": "実行済み：{{action}}",
    "timerSet": "{{amount}} {{unit}} のタイマーを設定しました",
    "chatPending": "メッセージを処理中です...",
    "suggestion": {
      "watchLive": "ライブTVを見る",
      "search": "コンテンツを検索",
      "listenRadio": "ラジオを聴く"
    },
    "error": {
      "micDenied": "マイクへのアクセスが拒否されました",
      "notSupported": "このブラウザでは音声コマンドはサポートされていません",
      "recognitionFailed": "理解できませんでした。もう一度お試しください。"
    }
  },
  "errors": {
    "networkError": "ネットワークエラー。接続を確認してください",
    "loadingFailed": "[ja] Loading Failed",
    "tryAgain": "もう一度お試しください",
    "offline": {
      "title": "[ja] No Internet Connection",
      "message": "[ja] You are currently offline. Some features may not be available.",
      "ttsMessage": "[ja] No internet connection. You are now in offline mode."
    },
    "online": {
      "title": "[ja] Connection Restored",
      "message": "[ja] You are back online.",
      "ttsMessage": "[ja] Internet connection restored."
    },
    "api": {
      "badRequest": "[ja] Something went wrong. Please try again.",
      "unauthorized": "[ja] Please log in to continue.",
      "forbidden": "[ja] You do not have permission to access this content.",
      "notFound": "[ja] The content you are looking for is not available.",
      "rateLimit": "[ja] You are making too many requests. Please wait a moment.",
      "serverError": "[ja] Our servers are having issues. Please try again later.",
      "unknown": "[ja] Something went wrong. Please try again.",
      "networkTimeout": "[ja] Unable to connect to our servers. Please check your connection.",
      "offlineMessage": "[ja] You are offline. Please check your internet connection.",
      "requestFailed": "[ja] Something went wrong. Please try again."
    },
    "voice": {
      "permissionDenied": "[ja] Microphone access is required for voice commands. Please enable it in Settings.",
      "recognitionFailed": "[ja] I didn't understand that. Please try again.",
      "commandFailed": "[ja] Voice command failed. Please try again."
    },
    "widget": {
      "loadFailed": "[ja] Unable to load widget. Please try again."
    },
    "buttons": {
      "ok": "[ja] OK",
      "retry": "[ja] Retry",
      "cancel": "[ja] Cancel"
    },
    "title": "[ja] Error",
    "networkUnavailable": "[ja] Network unavailable",
    "no_audio_url": "オーディオURLがありません",
    "connection_failed": "接続失敗",
    "quota_exceeded": "クォータ超過",
    "server_error": "サーバーエラー"
  },
  "player": {
    "loading": "読み込み中...",
    "retry": "再試行",
    "error": "再生エラー",
    "back": "[ja] ← Back",
    "liveBadge": "[ja] LIVE",
    "noStream": "[ja] Stream not available",
    "loadError": "[ja] Failed to load stream",
    "settings": "設定",
    "subtitles": "[ja] Subtitles",
    "playbackSpeed": "[ja] Playback Speed",
    "quality": "画質",
    "auto": "自動",
    "previousChapter": "[ja] Previous chapter",
    "nextChapter": "[ja] Next chapter",
    "skipBackward": "[ja] Skip backward 30 seconds",
    "skipForward": "[ja] Skip forward 30 seconds",
    "restart": "最初から再生",
    "subtitlesOff": "オフ",
    "speed": "速度",
    "subscription": {
      "requiredTitle": "[ja] Subscription Required",
      "requiredMessage": "[ja] requires a paid subscription",
      "upgradeInfo": "[ja] Upgrade your subscription to access premium content",
      "upgrade": "[ja] Upgrade Now"
    },
    "ai": {
      "dub": "Dub",
      "dubbing": "吹き替え",
      "featuresTitle": "AI機能",
      "languagePrimary": "プライマリ",
      "languageSecondary": "セカンダリ（任意）",
      "languageTitle": "AI言語",
      "liveTranslate": "リアルタイム翻訳",
      "selectLanguage": "言語を選択",
      "split": "分割",
      "togglePanel": "AIパネルの切り替え",
      "translate": "翻訳",
      "trivia": "トリビア",
      "triviaToggle": "[ja] Trivia"
    },
    "catchup": {
      "description": "冒頭を見逃しましたか？AIが生成したこれまでのあらすじを取得しましょう。",
      "generateSummary": "要約を生成",
      "summaryTitle": "要約",
      "title": "追いつき視聴",
      "keyPoints": "[ja] Key Points",
      "transcript": "[ja] Transcript"
    },
    "chat": {
      "title": "ライブチャット",
      "messagePlaceholder": "メッセージを入力..."
    },
    "companion": {
      "noContext": "このコンテンツの文化的背景はまだありません。",
      "quizComplete": "クイズ完了",
      "quizRetry": "再試行",
      "quizStart": "クイズを開始",
      "quizTitle": "知識を試す準備はできましたか？",
      "quizTryAgain": "再試行",
      "tabContext": "コンテキスト",
      "tabQuiz": "クイズ",
      "tabVocabulary": "語彙",
      "tapWords": "字幕の単語をタップしてここに追加",
      "title": "AIコンパニオン",
      "loadError": "AI学習データの読み込みに失敗しました"
    },
    "controls": {
      "audioTrack": "オーディオトラック",
      "continueWatching": "視聴を続ける",
      "dismiss": "閉じる",
      "goBack": "戻る",
      "navigateBack": "前に戻る",
      "on": "ON",
      "pause": "一時停止",
      "play": "再生",
      "preview": "プレビュー",
      "selected": "選択済み",
      "send": "送信",
      "skip": "スキップ",
      "close": "[ja] Close",
      "exitFullscreen": "[ja] Exit Fullscreen",
      "fullscreen": "[ja] Fullscreen",
      "restart": "[ja] Restart",
      "skipBackward": "[ja] Skip Backward",
      "skipForward": "[ja] Skip Forward",
      "volume": "[ja] Volume"
    },
    "dubbing": {
      "notNow": "今はしない",
      "premiumMessage": "ライブ吹替にはPremiumまたはBeta 500サブスクリプションが必要です",
      "premiumTitle": "プレミアム機能",
      "upgrade": "アップグレード",
      "voiceTitle": "吹替音声",
      "settings_title": "ライブ吹き替え設定",
      "target_language": "ターゲット言語"
    },
    "errors": {
      "streamLimitMessage": "同時ストリーム数の上限 {{maxStreams}} に達しました。別のストリームを停止するか、プランをアップグレードしてください。",
      "streamLimitTitle": "ストリーム制限に達しました",
      "upgradePlan": "プランをアップグレード"
    },
    "audio_description": "音声説明",
    "dismiss": "閉じる",
    "scene_search": "シーン検索",
    "search_placeholder": "シーンを検索...",
    "language_ratio": "言語学習比率",
    "go_back": "戻る",
    "sleepTimer": {
      "title": "スリープタイマー",
      "subtitle": "設定した時間後に自動的に再生を一時停止",
      "minutes": "{{count}}分",
      "customPlaceholder": "カスタム分数",
      "set": "タイマー設定",
      "remaining": "{{time}}後にスリープ",
      "extend": "+15分",
      "cancel": "タイマーキャンセル",
      "off": "[ja] Off",
      "setTimer": "[ja] Set Sleep Timer"
    },
    "openSubs": {
      "title": "字幕を検索",
      "searchPlaceholder": "タイトルで検索...",
      "search": "検索",
      "searchFailed": "検索に失敗しました。再試行してください。",
      "downloads": "{{count}}件のダウンロード",
      "noResults": "字幕が見つかりません"
    },
    "dialogue": {
      "cancel": "[ja] Cancel",
      "close": "[ja] Close",
      "placeholder": "[ja] Type your message...",
      "selectCharacter": "[ja] Select Character",
      "send": "[ja] Send",
      "sharedSession": "[ja] Shared Session",
      "waitingForTurn": "[ja] Waiting for your turn...",
      "yourAvatar": "[ja] Your Avatar"
    },
    "interaction": {
      "next": "[ja] Next",
      "previous": "[ja] Previous",
      "skip": "スキップ",
      "start": "インタラクション開始",
      "window": "インタラクション時間：{{duration}} 秒"
    },
    "pauseAsk": {
      "askAgain": "[ja] Ask Again",
      "placeholder": "[ja] Ask about this scene...",
      "resume": "[ja] Resume",
      "resumeMovie": "[ja] Resume Movie",
      "selectCharacter": "[ja] Select Character",
      "title": "[ja] Pause & Ask"
    },
    "phraseBreakdown": {
      "literal": "直訳",
      "meaning": "意味",
      "origin": "語源",
      "funFact": "豆知識",
      "usage": "使用頻度：{{level}}"
    },
    "translation": {
      "example": "例文：",
      "arrow": "→"
    },
    "subtitleMode": {
      "title": "字幕モード",
      "modes": {
        "regular": {
          "name": "標準",
          "description": "母音記号なしの標準ヘブライ語字幕"
        },
        "nikud": {
          "name": "ニクード",
          "description": "読みやすいよう母音記号付きのヘブライ語"
        },
        "shoresh": {
          "name": "ショレシュ",
          "description": "語根ハイライト付きの語源学習"
        },
        "engrew": {
          "name": "エングルー",
          "description": "ヘブライ語文脈付きの英語音写"
        },
        "heblish": {
          "name": "ヘブリッシュ",
          "description": "ヘブライ語用語と文化的文脈を含む英語"
        },
        "grammarFlip": {
          "name": "文法反転",
          "description": "英単語でのヘブライ語文構造"
        },
        "slangSynthesis": {
          "name": "スラング解説",
          "description": "文化的なスラングと慣用句の説明"
        }
      }
    }
  },
  "empty": {
    "noContent": "[ja] No content available",
    "tryAnotherCategory": "[ja] Try selecting another category",
    "noPodcasts": "[ja] No podcasts available",
    "tryLater": "[ja] Try again later",
    "noResults": "[ja] No results found"
  },
  "content": {
    "play": "[ja] Play",
    "addToList": "[ja] Add to List",
    "inList": "[ja] In List",
    "details": "[ja] Details",
    "synopsis": "[ja] Synopsis",
    "genre": "ジャンル",
    "genres": "[ja] Genres",
    "runtime": "[ja] Runtime",
    "released": "[ja] Released",
    "director": "監督",
    "starring": "[ja] Starring",
    "cast": "キャスト",
    "season": "シーズン",
    "seasons": "シーズン",
    "episode": "エピソード",
    "episodes": "エピソード",
    "ep": "[ja] Ep",
    "selectSeason": "[ja] Select Season",
    "noEpisodes": "[ja] No episodes available",
    "noEpisodesAvailable": "[ja] No episodes available to play",
    "loadingSeries": "[ja] Loading series information...",
    "votes": "[ja] votes",
    "rating": "評価",
    "imdbRating": "[ja] IMDB Rating",
    "preview": "[ja] Preview",
    "previewPlaying": "[ja] Preview playing",
    "trailerPlaying": "[ja] Trailer playing",
    "watchTrailer": "予告編を見る",
    "youMayAlsoLike": "[ja] You May Also Like",
    "relatedContent": "[ja] Related Content",
    "notFound": "[ja] Content not found",
    "availableSubtitles": "[ja] Available Subtitles",
    "subtitleSelected": "[ja] Selected: {{language}}"
  },
  "breadcrumbs": {
    "series": "[ja] Series",
    "movie": "[ja] Movie",
    "watching": "[ja] Watching",
    "channel": "[ja] Channel",
    "station": "[ja] Station",
    "podcast": "[ja] Podcast",
    "watchlist": "[ja] Watchlist",
    "downloads": "[ja] Downloads"
  },
  "favorites": {
    "title": "お気に入り",
    "items": "[ja] items",
    "empty": "[ja] No favorites yet",
    "emptyHint": "[ja] Add items to your favorites"
  },
  "downloads": {
    "title": "ダウンロード",
    "items": "[ja] items",
    "storage": "ストレージ",
    "empty": "[ja] No downloads",
    "emptyHint": "[ja] Download content for offline viewing",
    "paused": "一時停止中"
  },
  "watchlist": {
    "filters": {
      "all": "[ja] All",
      "continue": "[ja] Continue Watching",
      "movies": "[ja] Movies",
      "series": "[ja] Series",
      "kids": "[ja] Kids",
      "judaism": "[ja] Judaism",
      "podcasts": "[ja] Podcasts",
      "radio": "[ja] Radio"
    },
    "title": "ウォッチリスト",
    "items": "[ja] items",
    "watched": "[ja] watched",
    "empty": "[ja] Your watchlist is empty",
    "emptyHint": "[ja] Start watching and items will appear here"
  },
  "widgets": {
    "empty": "[ja] No widgets yet",
    "emptyHint": "[ja] Your widgets will appear here",
    "emptyPersonal": "[ja] No personal widgets yet",
    "emptyPersonalHint": "[ja] Create your first personal widget or add system widgets above",
    "itemsTotal": "[ja] total widgets",
    "systemWidgets": "[ja] System Widgets",
    "systemWidgetsHint": "[ja] Browse and add widgets to your collection",
    "myWidgets": "[ja] My Personal Widgets",
    "myWidgetsHint": "[ja] Widgets you have created",
    "personalWidgets": "[ja] My Widgets",
    "noSystemWidgets": "[ja] No system widgets available",
    "added": "[ja] Added",
    "add": "[ja] Add",
    "remove": "[ja] Remove",
    "show": "[ja] Show",
    "hidden": "[ja] Hidden",
    "addToCollection": "[ja] Add to My Widgets",
    "removeFromCollection": "[ja] Remove from My Widgets",
    "contentTypes": {
      "liveChannel": "[ja] Live Channel",
      "iframe": "[ja] Web Content",
      "podcast": "[ja] Podcast",
      "radio": "[ja] Radio",
      "vod": "[ja] Video",
      "custom": "[ja] Custom",
      "widget": "[ja] Widget"
    },
    "form": {
      "title": "[ja] Create Widget",
      "basicInfo": "[ja] Basic Information",
      "titlePlaceholder": "[ja] Widget Title",
      "titleRequired": "[ja] Widget Title is required",
      "descriptionPlaceholder": "[ja] Description (optional)",
      "iconPlaceholder": "[ja] Icon emoji (e.g., 📺)",
      "content": "[ja] Content",
      "fromLibrary": "[ja] From Library",
      "iframe": "[ja] iFrame",
      "selectContent": "[ja] Select Content (Channels, Podcasts, Shows, etc.)",
      "iframeUrl": "[ja] iFrame URL",
      "iframeUrlRequired": "[ja] iFrame URL is required",
      "iframeTitle": "[ja] iFrame Title",
      "positionSize": "[ja] Position & Size",
      "behavior": "[ja] Behavior",
      "mutedByDefault": "[ja] Muted by Default",
      "closable": "[ja] Closable",
      "draggable": "[ja] Draggable",
      "widgetOrder": "[ja] Widget Order",
      "orderPlaceholder": "[ja] Order (0 = first)",
      "saveWidget": "[ja] Save Widget",
      "saving": "[ja] Saving...",
      "cancel": "[ja] Cancel",
      "change": "[ja] Change"
    }
  },
  "trending": {
    "title": "[ja] What's Trending in Israel",
    "noTopics": "[ja] No trending topics available",
    "topStory": "[ja] TOP STORY",
    "sources": "[ja] Sources",
    "categories": {
      "security": "[ja] Security",
      "politics": "[ja] Politics",
      "tech": "[ja] Tech",
      "culture": "[ja] Culture",
      "sports": "[ja] Sports",
      "economy": "[ja] Economy",
      "entertainment": "[ja] Entertainment",
      "weather": "[ja] Weather",
      "health": "[ja] Health",
      "general": "[ja] General"
    }
  },
  "cultures": {
    "title": "[ja] Select Your Culture",
    "select": "[ja] Select Culture",
    "selectCulture": "[ja] Choose Your Culture",
    "selectCultureDescription": "[ja] Select your cultural community to personalize your experience",
    "changeCulture": "[ja] Change Culture",
    "israeli": {
      "name": "[ja] Israeli",
      "description": "[ja] Israeli expat community content"
    },
    "chinese": {
      "name": "[ja] Chinese",
      "description": "[ja] Chinese community content"
    },
    "japanese": {
      "name": "[ja] Japanese",
      "description": "[ja] Japanese community content"
    },
    "korean": {
      "name": "[ja] Korean",
      "description": "[ja] Korean community content"
    },
    "indian": {
      "name": "[ja] Indian",
      "description": "[ja] Indian community content"
    }
  },
  "cultureTrending": {
    "whatsHotIn": "[ja] What's Hot in {{location}}",
    "noTopics": "[ja] No trending topics available",
    "sources": "[ja] Sources",
    "categories": {
      "security": "[ja] Security",
      "politics": "[ja] Politics",
      "tech": "[ja] Tech",
      "technology": "[ja] Technology",
      "culture": "[ja] Culture",
      "sports": "[ja] Sports",
      "economy": "[ja] Economy",
      "finance": "[ja] Finance",
      "entertainment": "[ja] Entertainment",
      "weather": "[ja] Weather",
      "health": "[ja] Health",
      "food": "[ja] Food",
      "fashion": "[ja] Fashion",
      "travel": "[ja] Travel",
      "history": "[ja] History",
      "expat": "[ja] Expat Life",
      "general": "[ja] General"
    }
  },
  "cultureClock": {
    "timeIn": "{{location}}の時間",
    "shabbat": "シャバット",
    "weekend": "週末"
  },
  "cultureCities": {
    "connectionTo": "[ja] {{city}} Connection",
    "explore": "[ja] Explore {{city}}",
    "noContent": "[ja] No content available for this city",
    "categories": {
      "all": "[ja] All",
      "history": "[ja] History",
      "culture": "[ja] Culture",
      "finance": "[ja] Finance",
      "tech": "[ja] Tech",
      "food": "[ja] Food",
      "expat": "[ja] Expat Life",
      "news": "[ja] News",
      "entertainment": "[ja] Entertainment"
    }
  },
  "clock": {
    "israel": "[ja] Israel",
    "local": "[ja] Local",
    "shabbatShalom": "[ja] Shabbat Shalom!",
    "erevShabbat": "[ja] Erev Shabbat",
    "candleLighting": "[ja] Candle Lighting",
    "parasha": "[ja] Parasha"
  },
  "ritual": {
    "title": "[ja] Morning Ritual",
    "greeting": "[ja] Good Morning!",
    "israelUpdate": "[ja] It's afternoon in Israel, news is reporting on ongoing developments",
    "recommendation": "[ja] We recommend starting with morning news then switching to radio",
    "preparingRitual": "[ja] Preparing your morning ritual...",
    "israelTime": "[ja] Israel Time",
    "day": "[ja] Day",
    "letsStart": "[ja] Let's Start",
    "skipToday": "[ja] Skip for Today",
    "finish": "[ja] Finish",
    "noContentNow": "[ja] No content available right now",
    "typeLive": "[ja] Live",
    "typeRadio": "[ja] Radio",
    "typeVideo": "[ja] Video"
  },
  "watchParty": {
    "title": "[ja] Watch Party",
    "create": "[ja] Create Party",
    "join": "[ja] Join Party",
    "active": "[ja] Party Active",
    "createTitle": "[ja] Create Watch Party",
    "joinTitle": "[ja] Join Party",
    "enterCode": "[ja] Enter Room Code",
    "roomCode": "[ja] Room Code",
    "copyCode": "[ja] Copy Code",
    "codeCopied": "[ja] Code Copied!",
    "participants": "[ja] Participants",
    "host": "[ja] Host",
    "you": "[ja] You",
    "leave": "[ja] Leave Party",
    "end": "[ja] End Party",
    "chat": "[ja] Chat",
    "sendMessage": "[ja] Send Message",
    "typeMessage": "[ja] Type a message...",
    "synced": "[ja] Synced",
    "syncing": "[ja] Syncing...",
    "hostPaused": "[ja] Host Paused",
    "userJoined": "[ja] {{name}} joined",
    "userLeft": "[ja] {{name}} left",
    "partyEnded": "[ja] The party has ended",
    "connecting": "[ja] Connecting...",
    "options": {
      "chatEnabled": "[ja] Enable Chat",
      "syncPlayback": "[ja] Sync Playback"
    },
    "errors": {
      "invalidCode": "[ja] Invalid code",
      "partyFull": "[ja] Party is full",
      "partyEnded": "[ja] Party has ended",
      "connectionError": "[ja] Connection error",
      "createFailed": "[ja] Failed to create party",
      "joinFailed": "[ja] Failed to join party"
    },
    "audio": {
      "mute": "[ja] Mute",
      "unmute": "[ja] Unmute",
      "speaking": "[ja] Speaking",
      "connecting": "[ja] Connecting to audio...",
      "noAudio": "[ja] Audio not available"
    },
    "textOnlyMode": "[ja] Text Chat Only",
    "endParty": "[ja] End Party"
  },
  "footer": {
    "brandDescription": "[ja] Your home in the USA. TV broadcasts, VOD, radio and podcasts in Hebrew.",
    "browse": "[ja] Browse",
    "account": "[ja] Account",
    "support": "サポート",
    "legal": "法的情報",
    "location": "[ja] New York, USA",
    "links": {
      "home": "[ja] Home",
      "liveTV": "[ja] Live TV",
      "vod": "[ja] Movies & Series",
      "radio": "[ja] Radio",
      "podcasts": "[ja] Podcasts",
      "judaism": "[ja] Judaism",
      "profile": "[ja] My Profile",
      "favorites": "[ja] Favorites",
      "watchlist": "[ja] Watchlist",
      "subscribe": "[ja] Subscribe",
      "downloads": "[ja] Downloads",
      "help": "[ja] Help Center",
      "faq": "[ja] FAQ",
      "contact": "[ja] Contact Us",
      "feedback": "[ja] Feedback",
      "terms": "[ja] Terms of Service",
      "privacy": "[ja] Privacy Policy",
      "cookies": "[ja] Cookie Policy",
      "licenses": "[ja] Licenses"
    },
    "newsletter": {
      "title": "[ja] Stay Updated",
      "description": "[ja] Subscribe to our newsletter for the latest updates and exclusive content.",
      "placeholder": "[ja] Enter your email",
      "success": "[ja] Thanks for subscribing!"
    },
    "apps": {
      "title": "[ja] Get the App",
      "downloadOn": "[ja] Download on",
      "getItOn": "[ja] Get it on",
      "appStore": "[ja] App Store",
      "googlePlay": "[ja] Google Play"
    },
    "social": {
      "facebook": "[ja] Facebook",
      "twitter": "[ja] Twitter",
      "instagram": "[ja] Instagram",
      "youtube": "[ja] YouTube"
    },
    "copyright": "© {{year}} Bayit+. 全著作権所有。",
    "poweredBy": "[ja] Powered by",
    "sitemap": "サイトマップ",
    "accessibility": "アクセシビリティ",
    "navigation": "[ja] Navigation",
    "liveTV": "[ja] Live TV",
    "moviesAndSeries": "[ja] Movies & Series",
    "radioStations": "[ja] Radio Stations",
    "myProfile": "[ja] My Profile",
    "subscriptions": "[ja] Subscriptions",
    "helpAndSupport": "[ja] Help & Support",
    "termsOfUse": "[ja] Terms of Use",
    "privacyPolicy": "[ja] Privacy Policy",
    "contactUs": "[ja] Contact Us"
  },
  "chapters": {
    "title": "[ja] Chapters",
    "noChapters": "[ja] No chapters available",
    "generating": "[ja] Generating chapters...",
    "jumpTo": "[ja] Jump to",
    "current": "[ja] Now",
    "categories": {
      "intro": "[ja] Introduction",
      "news": "[ja] News",
      "security": "[ja] Security",
      "politics": "[ja] Politics",
      "economy": "[ja] Economy",
      "sports": "[ja] Sports",
      "weather": "[ja] Weather",
      "culture": "[ja] Culture",
      "conclusion": "[ja] Conclusion"
    },
    "chapterLabel": "第{{number}}章",
    "chapter_number": "第{{number}}章"
  },
  "admin": {
    "brand": {
      "title": "Bayit+ 管理画面",
      "subtitle": "システム管理"
    },
    "backToApp": "アプリに戻る",
    "refunds": {
      "subtitle": "返金リクエストを管理",
      "approveModal": {
        "title": "承認確認",
        "message": "{{amount}}の返金を承認しますか？"
      },
      "confirmApprove": "{{amount}}の返金を承認しますか？",
      "confirmDelete": "返金リクエストを削除しますか？",
      "rejectModal": {
        "title": "返金リクエストを拒否",
        "message": "{{amount}}の返金を拒否",
        "reasonLabel": "拒否理由",
        "reasonPlaceholder": "拒否理由を入力してください...",
        "submitButton": "リクエストを拒否"
      },
      "status": {
        "pending": "保留中",
        "approved": "承認済み",
        "rejected": "拒否済み"
      },
      "columns": {
        "id": "ID",
        "user": "ユーザー",
        "amount": "金額",
        "reason": "理由",
        "status": "ステータス",
        "requestDate": "リクエスト日"
      },
      "stats": {
        "pendingTitle": "承認待ち",
        "approvedTitle": "承認済み",
        "rejectedTitle": "拒否済み",
        "totalRefunded": "総返金額"
      },
      "emptyMessage": "返金リクエストが見つかりません",
      "errors": {
        "rejectReasonRequired": "拒否理由を入力してください"
      },
      "title": "返金"
    },
    "plans": {
      "title": "プラン管理",
      "subtitle": "サブスクリプションプランを設定・管理",
      "createButton": "新規プラン",
      "inactive": "無効",
      "subscribersLabel": "登録者：",
      "intervals": {
        "monthly": "月",
        "yearly": "年"
      },
      "trialDays": "{{days}}日間トライアル",
      "modal": {
        "editTitle": "プランを編集",
        "createTitle": "新規プラン"
      },
      "form": {
        "nameEn": "名前（英語）",
        "nameHe": "名前（ヘブライ語）",
        "price": "価格（$）",
        "interval": "請求期間",
        "trialDays": "トライアル日数",
        "features": "機能（1行に1つ）",
        "active": "有効なプラン"
      },
      "errors": {
        "requiredFields": "名前と価格は必須です"
      },
      "confirmDelete": "プラン「{{name}}」を削除しますか？"
    },
    "emailCampaigns": {
      "subtitle": "メールキャンペーンを作成・管理",
      "createButton": "新規キャンペーン",
      "searchPlaceholder": "キャンペーンを検索...",
      "emptyMessage": "キャンペーンが見つかりません",
      "status": {
        "draft": "下書き",
        "active": "有効",
        "scheduled": "予定",
        "completed": "完了"
      },
      "columns": {
        "name": "キャンペーン名",
        "status": "ステータス",
        "sent": "送信数",
        "opened": "開封数",
        "clicked": "クリック数",
        "created": "作成日",
        "actions": "アクション"
      },
      "editModal": {
        "title": "キャンペーンを編集"
      },
      "sendTestEmail": "テスト送信",
      "confirmSend": "キャンペーン「{{name}}」を送信しますか？",
      "confirmDelete": "キャンペーン「{{name}}」を削除しますか？",
      "testEmailSent": "テストメールが送信されました！",
      "createModal": {
        "title": "新規メールキャンペーン"
      },
      "form": {
        "name": "キャンペーン名",
        "namePlaceholder": "例：年末セール",
        "subject": "メール件名",
        "subjectPlaceholder": "受信者に表示される件名",
        "body": "コンテンツ",
        "bodyPlaceholder": "メール本文...",
        "submitButton": "キャンペーンを作成",
        "requiredFields": "名前と件名は必須です"
      },
      "testModal": {
        "title": "テストメールを送信",
        "emailLabel": "メールアドレス",
        "emailPlaceholder": "test@example.com",
        "submitButton": "テスト送信"
      },
      "errors": {
        "requiredFields": "名前と件名は必須です"
      }
    },
    "dashboard": {
      "subtitle": "システム概要",
      "refresh": "更新",
      "timeAgo": {
        "minutes": "{{count}}分前",
        "hours": "{{count}}時間前"
      },
      "title": "ダッシュボード",
      "users": "ユーザー",
      "revenue": "収益",
      "subscriptions": "サブスクリプション",
      "recentActivity": "最近のアクティビティ",
      "quickActions": "クイックアクション"
    },
    "common": {
      "all": "すべて",
      "cancel": "キャンセル",
      "save": "保存",
      "active": "有効",
      "back": "戻る",
      "filterAction": "アクション",
      "filterResource": "リソース",
      "filterUser": "ユーザー",
      "filterDateRange": "日付範囲"
    },
    "stats": {
      "totalUsers": "総ユーザー数",
      "activeUsers": "アクティブユーザー",
      "newToday": "本日の新規",
      "newThisWeek": "今週の新規",
      "totalRevenue": "総収益",
      "revenueToday": "本日の収益",
      "revenueMonth": "今月の収益",
      "arpu": "ユーザーあたりの平均収益",
      "activeSubscriptions": "有効なサブスクリプション",
      "churnRate": "解約率"
    },
    "actions": {
      "new": "新規",
      "addUser": "ユーザーを追加",
      "newCampaign": "新規キャンペーン",
      "sendEmail": "メールを送信",
      "viewReports": "レポートを表示"
    },
    "auditActions": {
      "user_created": "ユーザー作成",
      "user_updated": "ユーザー更新",
      "user_deleted": "ユーザー削除",
      "user_role_changed": "ユーザー権限変更",
      "campaign_created": "キャンペーン作成",
      "campaign_updated": "キャンペーン更新",
      "campaign_deleted": "キャンペーン削除",
      "campaign_activated": "キャンペーン有効化",
      "subscription_created": "サブスクリプション作成",
      "subscription_updated": "サブスクリプション更新",
      "subscription_canceled": "サブスクリプションキャンセル",
      "subscription_deleted": "サブスクリプション削除",
      "refund_processed": "返金処理",
      "payment_received": "支払い受領",
      "settings_updated": "設定更新",
      "login": "ログイン",
      "logout": "ログアウト",
      "content_created": "コンテンツ作成",
      "content_updated": "コンテンツ更新",
      "content_deleted": "コンテンツ削除",
      "content_published": "コンテンツ公開",
      "content_unpublished": "コンテンツ非公開",
      "category_created": "カテゴリ作成",
      "category_updated": "カテゴリ更新",
      "category_deleted": "カテゴリ削除",
      "live_channel_created": "ライブチャンネル作成",
      "live_channel_updated": "ライブチャンネル更新",
      "live_channel_deleted": "ライブチャンネル削除",
      "radio_station_created": "ラジオ局作成",
      "radio_station_updated": "ラジオ局更新",
      "radio_station_deleted": "ラジオ局削除",
      "podcast_created": "ポッドキャスト作成",
      "podcast_updated": "ポッドキャスト更新",
      "podcast_deleted": "ポッドキャスト削除",
      "podcast_episode_created": "ポッドキャストエピソード作成",
      "podcast_episode_updated": "ポッドキャストエピソード更新",
      "podcast_episode_deleted": "ポッドキャストエピソード削除",
      "content_imported": "コンテンツインポート",
      "widget_created": "ウィジェット作成",
      "widget_updated": "ウィジェット更新",
      "widget_deleted": "ウィジェット削除",
      "widget_published": "ウィジェット公開",
      "widget_unpublished": "ウィジェット非公開"
    },
    "placeholder": {
      "userId": "ユーザーIDを入力",
      "discount": "0"
    },
    "titles": {
      "users": "ユーザー",
      "transactions": "取引",
      "subscriptions": "サブスクリプション",
      "refunds": "返金",
      "plans": "プラン",
      "campaigns": "キャンペーン",
      "auditLogs": "監査ログ",
      "pushNotifications": "プッシュ通知",
      "billing": "請求",
      "marketing": "マーケティング",
      "content": "コンテンツライブラリ",
      "categories": "カテゴリ",
      "liveChannels": "ライブチャンネル",
      "radioStations": "ラジオ局",
      "podcasts": "ポッドキャスト",
      "settings": "設定"
    },
    "nav": {
      "dashboard": "ダッシュボード",
      "users": "ユーザー",
      "campaigns": "キャンペーン",
      "billing": "請求",
      "billingOverview": "概要",
      "transactions": "取引",
      "refunds": "返金",
      "subscriptions": "サブスクリプション",
      "subscriptionsList": "登録者",
      "plans": "プラン",
      "marketing": "マーケティング",
      "marketingDashboard": "概要",
      "emailCampaigns": "メールキャンペーン",
      "pushNotifications": "プッシュ通知",
      "content": "コンテンツ",
      "contentLibrary": "コンテンツライブラリ",
      "categories": "カテゴリ",
      "liveChannels": "ライブチャンネル",
      "radioStations": "ラジオ局",
      "podcasts": "ポッドキャスト",
      "widgets": "ウィジェット",
      "recordings": "録画",
      "uploads": "アップロード",
      "settings": "設定",
      "auditLogs": "監査ログ",
      "librarian": "ライブラリアンエージェント",
      "featured": "おすすめ"
    },
    "featured": {
      "title": "おすすめコンテンツ",
      "subtitle": "ホームページカルーセルのおすすめコンテンツを管理",
      "empty": "おすすめコンテンツがありません",
      "emptyHint": "おすすめアイテムはホームページの各カルーセルに表示されます",
      "count": "{{count}}件",
      "confirmUnfeature": "おすすめから削除しますか？",
      "remove": "削除",
      "unsavedChanges": "保存されていない変更があります",
      "section": {
        "title": "{{name}}",
        "itemCount": "{{count}}件",
        "itemCount_plural": "{{count}}件",
        "empty": "おすすめアイテムがありません",
        "emptyHint": "おすすめアイテムはホームページの{{name}}カルーセルに表示されます"
      },
      "saveButton": "{{count}}セクションを保存",
      "saveButton_plural": "{{count}}セクションを保存",
      "saving": "保存中...",
      "saveSuccess": "おすすめコンテンツが正常に更新されました",
      "saveFailed": "おすすめコンテンツの保存に失敗しました",
      "removeConfirm": "{{section}}から削除しますか？",
      "removeSuccess": "{{section}}から削除しました"
    },
    "recordings": {
      "title": "録画管理",
      "subtitle": "プラットフォーム全体のユーザー録画を管理",
      "totalRecordings": "総録画数",
      "totalStorage": "総ストレージ",
      "totalUsers": "録画ユーザー数",
      "activeSessions": "アクティブセッション",
      "searchPlaceholder": "タイトル、ユーザー、チャンネルで検索...",
      "user": "ユーザー",
      "confirmDelete": "録画「{{title}}」を削除しますか？この操作は元に戻せません。",
      "deleteRecording": "録画を削除",
      "deleteSuccess": "録画が正常に削除されました",
      "deleteFailed": "録画の削除に失敗しました",
      "loadFailed": "録画の読み込みに失敗しました",
      "noRecordings": "録画が見つかりません",
      "noRecordingsHint": "システムにユーザー録画がまだありません。"
    },
    "uploads": {
      "title": "アップロード管理",
      "subtitle": "コンテンツアップロードと自動フォルダー監視を管理",
      "activeUploads": "アクティブアップロード",
      "noActiveUploads": "アクティブなアップロードがありません",
      "queuedUploads": "キュー内のアップロード",
      "queued": "キュー",
      "andMore": "他{{count}}件",
      "monitoredFolders": "監視フォルダー",
      "noMonitoredFolders": "監視フォルダーが設定されていません",
      "configureFoldersHelp": "「フォルダーを追加」をクリックして自動アップロード用の監視フォルダーを設定",
      "addFolder": "フォルダーを追加",
      "editFolder": "フォルダーを編集",
      "deleteFolder": "フォルダーを削除",
      "confirmDelete": "このフォルダーを削除しますか？",
      "triggerUpload": "アップロードを開始",
      "triggerUploadSuccess": "{{files_found}}件の新しいファイルが見つかりました",
      "triggerUploadFailed": "アップロードスキャンの開始に失敗しました",
      "noFilesFound": "監視フォルダーに新しいファイルが見つかりません",
      "sessionIssue": "セッションの問題",
      "sessionIssueHelp": "セッションが期限切れの可能性があります。ページを更新して接続を復元してください。",
      "sessionExpired": "セッションが期限切れです。ページを更新するか再ログインしてください。",
      "unauthorized": "セッションが無効です。ページを更新してください。",
      "endpointNotFound": "アップロードサービスが利用できません。サーバー設定を確認してください。",
      "timeout": "アップロードスキャンがタイムアウトしました。再試行するか監視フォルダーを確認してください。",
      "wsDisconnected": "リアルタイム更新無効",
      "wsDisconnectedHelp": "WebSocket接続に失敗しました。キューステータスが古い可能性があります。ページは自動で再試行します。",
      "wsReconnecting": "リアルタイム更新に再接続中...",
      "uploadAlreadyRunning": "アップロードスキャンが既に進行中です。現在のアップロードが完了するまでお待ちください。",
      "uploadsActiveNotice": "アップロード進行中（{{processing}}件アクティブ、{{queued}}件キュー）。現在のバッチが完了するまで新しいスキャンは無効です。",
      "clearQueue": "キューをクリア",
      "clearQueueConfirmTitle": "アップロードキューをクリアしますか？",
      "clearQueueConfirmMessage": "{{count}}件のアクティブなジョブがキャンセルされます。この操作は元に戻せません。",
      "clearQueueSuccess": "キューが正常にクリアされました",
      "clearQueueFailed": "キューのクリアに失敗しました",
      "cancelUpload": "キャンセル",
      "cancelUploadConfirm": "このアップロードをキャンセルしますか？",
      "cancelUploadSuccess": "アップロードがキャンセルされました",
      "cancelUploadFailed": "アップロードのキャンセルに失敗しました",
      "resetCache": "キャッシュをリセット",
      "cacheResetSuccess": "キャッシュをクリア：{{count}}件のファイルが次回スキャン時に再スキャンされます",
      "cacheResetFailed": "キャッシュのリセットに失敗しました",
      "contentTypeFilters": "コンテンツタイプフィルター",
      "contentTypeFiltersHelp": "オプション - すべてのコンテンツタイプを処理するにはすべてのチェックを外してください",
      "moviesOnly": "映画のみ",
      "seriesOnly": "シリーズのみ",
      "audiobooksOnly": "オーディオブックのみ",
      "type": "タイプ",
      "lastScan": "最終スキャン",
      "systemInfo": "アップロードシステム情報",
      "systemInfoText": "アップロード中にローカルビデオファイルから字幕を自動抽出し、処理を高速化",
      "languagesInfo": "対応字幕言語：英語 (en)、ヘブライ語 (he)、スペイン語 (es)",
      "queueStatus": "アップロードキュー",
      "totalJobs": "合計",
      "processing": "処理中",
      "completed": "完了",
      "skipped": "スキップ",
      "failed": "失敗",
      "queuePaused": "キュー一時停止中",
      "resumeQueue": "再開",
      "activeUpload": "アクティブアップロード",
      "queuedItems": "キュー",
      "noQueuedItems": "キューにアイテムがありません",
      "addedAt": "追加日時",
      "recentCompleted": "最近完了",
      "stages": {
        "browserUpload": "サーバーにアップロード中",
        "hashCalculation": "ハッシュを計算中",
        "duplicateCheck": "重複をチェック中",
        "metadataExtraction": "メタデータを抽出中",
        "gcsUpload": "クラウドにアップロード中",
        "databaseInsert": "データベースに保存中",
        "imdbLookup": "IMDB情報を取得中",
        "subtitleExtraction": "字幕を抽出中",
        "completed": "完了",
        "failed": "失敗",
        "skipped": "スキップ"
      },
      "form": {
        "name": "フォルダー名",
        "namePlaceholder": "マイ映画フォルダー",
        "path": "フォルダーパス",
        "pathHelp": "サーバーパスを入力（例：/Volumes/USB Drive/Movies）",
        "contentType": "コンテンツタイプ",
        "enabled": "有効",
        "autoUpload": "自動アップロード"
      },
      "contentTypes": {
        "movie": "映画",
        "series": "シリーズ",
        "audiobook": "オーディオブック"
      },
      "errors": {
        "pathRequired": "フォルダーパスは必須です"
      },
      "manualUpload": {
        "title": "手動アップロード",
        "subtitle": "ファイルをドラッグ＆ドロップまたはフォルダーを選択",
        "dropHere": "ここにファイルをドロップまたはクリックして参照",
        "dropHereActive": "ファイルをドロップして追加",
        "selectFolder": "フォルダーを選択",
        "supportedFormats": "動画ファイルに対応（mp4, mkv, avi, mov, webm）",
        "selectedFiles": "選択されたファイル",
        "noFilesSelected": "ファイルが選択されていません",
        "clearAll": "すべてクリア",
        "uploadSelected": "選択をアップロード",
        "selectContentType": "アップロードのコンテンツタイプを選択",
        "uploadingFiles": "{{count}}件のファイルをキューに追加中...",
        "uploadSuccess": "{{count}}件のファイルをキューに正常に追加しました",
        "uploadFailed": "ファイルのキュー追加に失敗しました",
        "fileSize": "サイズ",
        "removeFile": "削除",
        "invalidFileType": "無効なファイルタイプです。動画ファイルのみ対応しています。",
        "filesCount": "{{count}}件のファイルが選択されました",
        "pendingRestore": "前回のセッションから{{count}}件のファイルが保留中",
        "pendingRestoreHint": "同じファイルをドロップまたは選択してアップロードキューを復元"
      }
    },
    "librarian": {
      "title": "ライブラリアンエージェント",
      "subtitle": "AI搭載の自律的コンテンツライブラリ管理",
      "loading": "ライブラリアンエージェントを読み込み中...",
      "loadingConfig": "設定を読み込み中...",
      "refresh": "更新",
      "errors": {
        "configError": "設定エラー",
        "configNotLoaded": "設定が読み込まれていません",
        "failedToLoad": "ライブラリアンデータの読み込みに失敗しました",
        "failedToLoadConfig": "ライブラリアン設定の読み込みに失敗しました",
        "failedToTrigger": "監査の開始に失敗しました。もう一度お試しください。",
        "failedToLoadDetails": "レポート詳細の読み込みに失敗しました。",
        "failedToRollback": "アクションのロールバックに失敗しました。",
        "failedToClearReports": "監査レポートのクリアに失敗しました。もう一度お試しください。",
        "failedToPause": "監査の一時停止に失敗しました",
        "failedToResume": "監査の再開に失敗しました",
        "failedToCancel": "監査のキャンセルに失敗しました",
        "failedToInterject": "AIエージェントへのメッセージ送信に失敗しました",
        "auditAlreadyRunning": "監査が既に実行中です。完了するかキャンセルしてから新しい監査を開始してください。",
        "budgetExceeded": "月間予算制限を超えました。監査を実行できません。",
        "contactAdmin": "適切な設定なしではライブラリアンページを読み込めません。\n管理者に連絡してください。"
      },
      "stats": {
        "systemHealth": "システム状態",
        "totalAudits": "総監査数（30日間）",
        "last30Days": "過去30日間",
        "issuesFixed": "修正された問題",
        "lastAudit": "最終監査",
        "never": "なし",
        "unknown": "不明"
      },
      "health": {
        "excellent": "優良",
        "good": "良好",
        "fair": "普通",
        "poor": "不良",
        "unknown": "不明"
      },
      "quickActions": {
        "title": "実行設定",
        "subtitle": "監査の設定と実行",
        "auditMode": "監査モード",
        "auditModeHelp": "チェック内容を選択",
        "dryRun": "プレビューモード",
        "dryRunHelp": "変更を加えずに何が変わるかを表示",
        "scopeFilters": "監査機能",
        "scopeFiltersHelp": "有効にする機能を選択（複数選択可）",
        "last24Hours": "最近のコンテンツのみ",
        "last24HoursHelp": "過去24時間に追加されたコンテンツに監査を制限",
        "cybTitlesOnly": "ダーティタイトルをクリーン",
        "cybTitlesOnlyHelp": "タイトルからファイル拡張子、品質マーカー、リリースタグを削除",
        "tmdbPostersOnly": "TMDBポスター＆メタデータ",
        "tmdbPostersOnlyHelp": "TMDBから不足しているポスター、説明、メタデータを取得",
        "openSubtitlesEnabled": "字幕を取得",
        "openSubtitlesEnabledHelp": "OpenSubtitlesから不足している字幕をダウンロード（HE/EN/ES）",
        "classifyOnly": "分類を確認",
        "classifyOnlyHelp": "映画とシリーズの分類エラーをチェックして修正",
        "purgeDuplicates": "重複を削除",
        "purgeDuplicatesHelp": "重複コンテンツを検出して削除",
        "auditType": "監査タイプ",
        "auditTypeHelp": "ルールベースまたはAI搭載監査を選択",
        "dailyAudit": "デイリー監査",
        "dailyBadge": "ルールベース • 高速 • 無料",
        "dailyDescription": "過去7日間に変更されたコンテンツに対して事前定義のチェックを実行。高速で予測可能、AIコストなし。",
        "aiAgentAudit": "AIエージェント監査",
        "aiAgentBadge": "AI搭載 • インテリジェント • 予算使用",
        "aiAgentDescription": "自律型AIエージェント（Claude）がチェックと修正について知的な判断を行います。より包括的ですがAPI予算を使用します。",
        "triggerDaily": "デイリー監査を実行",
        "triggerAI": "AIエージェント監査を実行",
        "auditRunningNotice": "監査が現在実行中です。完了するとボタンが有効になります。",
        "budgetLabel": "AIエージェント予算制限：${{budget}}",
        "budgetPerAudit": "監査あたりの予算",
        "monthlyBudgetUsed": "使用済み予算（30日間）",
        "monthlyBudgetLimit": "/ ${{limit}} 月間",
        "budgetWarning": "この監査を実行すると月間予算制限を超えます",
        "aiAuditSuccess": "AIエージェント監査が正常に開始されました。{{dryRun}}",
        "dailyAuditSuccess": "デイリー監査が正常に開始されました。{{dryRun}}",
        "dryRunMode": "（ドライランモード）",
        "rollbackSuccess": "アクションが正常にロールバックされました。"
      },
      "voice": {
        "title": "音声コントロール",
        "description": "音声でライブラリアンにコマンドを与えます。ボタンを押して自然に話しかけてください。",
        "pressToSpeak": "押して話す",
        "listening": "聞いています...",
        "transcript": "文字起こし",
        "processing": "コマンドを処理中...",
        "speaking": "ライブラリアンが応答中...",
        "examples": "コマンド例",
        "example1": "過去24時間の不足しているポスターをチェック",
        "example2": "CYBタイトルのメタデータを修正",
        "example3": "壊れたストリーミングURLをスキャン",
        "example4": "映画から字幕を抽出",
        "notSupported": "音声認識はお使いのブラウザでサポートされていません。Chrome、Edge、またはSafariをご利用ください。",
        "notAvailable": "音声コントロールは利用できません",
        "noSpeech": "音声が検出されませんでした。もう一度お試しください。",
        "noMicrophone": "マイクが検出されませんでした。デバイスを確認してください。",
        "microphoneBlocked": "マイクアクセスがブロックされました。ブラウザ設定で有効にしてください。",
        "error": "音声認識エラー：{{error}}",
        "startFailed": "音声認識の開始に失敗しました。もう一度お試しください。",
        "commandFailed": "コマンドの実行に失敗しました。もう一度お試しください。"
      },
      "schedules": {
        "title": "スケジュール監査",
        "subtitle": "日次・週次監査スケジュールを設定",
        "dailyTitle": "デイリー監査",
        "weeklyTitle": "週次AI監査",
        "schedule": "スケジュール",
        "time": "時間",
        "mode": "モード",
        "cost": "推定コスト",
        "status": "ステータス",
        "description": "説明",
        "viewInConsole": "Cloud Consoleで表示",
        "modifyNote": "スケジュールを変更するにはGoogle Cloud Consoleを使用",
        "editTitle": "スケジュールを編集",
        "editNotAvailable": "スケジュール編集は利用不可",
        "editNotAvailableMessage": "スケジュールの変更にはCloud Scheduler API統合が必要です。Google Cloud Consoleで直接変更するには「Cloud Consoleで表示」ボタンを使用してください。",
        "cronExpression": "Cron式",
        "cronHint": "形式：分 時 日 月 曜日（例：0 2 * * * = 毎日午前2時）",
        "patterns": {
          "daily": "毎日 {{hour}}:{{minute}}",
          "weekly": "毎週{{day}} {{hour}}:{{minute}}"
        },
        "days": {
          "sunday": "日曜日",
          "monday": "月曜日",
          "tuesday": "火曜日",
          "wednesday": "水曜日",
          "thursday": "木曜日",
          "friday": "金曜日",
          "saturday": "土曜日"
        }
      },
      "reports": {
        "title": "最近の監査レポート",
        "emptyMessage": "監査レポートがまだありません",
        "totalReports": "{{count}}件のレポート",
        "clearAll": "すべてクリア",
        "confirmClearAll": "すべての監査レポートをクリアしてもよろしいですか？この操作は元に戻せません。",
        "clearedSuccessfully": "すべての監査レポートが正常にクリアされました",
        "viewLogs": "ログを表示",
        "viewDetails": "詳細を表示",
        "columns": {
          "date": "日付",
          "type": "タイプ",
          "duration": "所要時間",
          "status": "ステータス",
          "issues": "問題",
          "fixes": "修正",
          "actions": "アクション"
        },
        "detailModal": {
          "title": "監査レポート：{{id}}",
          "summary": "概要",
          "status": "ステータス",
          "executionTime": "実行時間",
          "totalItems": "総アイテム数",
          "healthyItems": "正常なアイテム",
          "issuesFound": "検出された問題",
          "totalIssues": "検出された問題の合計",
          "seeInsightsBelow": "詳細は下のAIインサイトをご覧ください",
          "brokenStreams": "壊れたストリーム",
          "missingMetadata": "不足しているメタデータ",
          "misclassifications": "誤分類",
          "orphanedItems": "孤立したアイテム",
          "fixesApplied": "適用された修正",
          "totalFixes": "合計{{count}}件の修正",
          "aiInsights": "AIインサイト"
        }
      },
      "logs": {
        "title": "実行ログ",
        "liveAuditLog": "ライブ監査ログ",
        "executionLog": "監査実行ログ",
        "searchPlaceholder": "ログを検索...",
        "noLogs": "表示するログがありません",
        "noActiveAudit": "アクティブな監査なし",
        "triggerAuditToSee": "監査を開始するとここにライブ実行ログが表示されます",
        "auditType": "監査タイプ",
        "started": "開始",
        "completed": "完了",
        "lastLog": "最終ログ",
        "staleWarning": "{{seconds}}秒間新しいログがありません - ジョブが処理中またはスタックしている可能性があります",
        "pollingStatus": "ポーリングアクティブ • 最終確認",
        "connecting": "ライブ監査ログに接続中...",
        "aiInsightPrefix": "AIインサイト",
        "source": {
          "librarian": "ライブラリアン",
          "aiAgent": "AIエージェント"
        },
        "levels": {
          "debug": "デバッグ",
          "info": "情報",
          "warn": "警告",
          "error": "エラー",
          "success": "成功",
          "trace": "トレース"
        },
        "auditStarted": "監査開始",
        "brokenStreamsFound": "{{count}}件の壊れたストリームが見つかりました",
        "missingMetadataFound": "{{count}}件のメタデータ不足アイテムが見つかりました",
        "misclassificationsFound": "{{count}}件の誤分類アイテムが見つかりました",
        "orphanedItemsFound": "{{count}}件の孤立アイテムが見つかりました",
        "fixesApplied": "{{count}}件の修正を適用しました",
        "auditCompleted": "監査が{{status}}で{{duration}}秒で完了しました",
        "auditInitializing": "🚀 {{auditType}}監査を初期化中...",
        "dryRunMode": "⚠️ ドライランモードで実行中 - 変更は行われません",
        "liveMode": "✅ ライブモードで実行中 - 変更が適用されます",
        "budgetSet": "💰 予算制限：${{budget}}",
        "connectingToAgent": "🔗 Claude AIエージェントに接続中..."
      },
      "audit": {
        "types": {
          "aiAgent": "AIエージェント",
          "dailyIncremental": "デイリーインクリメンタル"
        },
        "pause": "一時停止",
        "resume": "再開",
        "cancel": "キャンセル",
        "interject": "割り込み",
        "interjectTitle": "AIエージェントにメッセージを送信",
        "interjectHint": "このメッセージは次の繰り返しでAIエージェントの会話に挿入されます。追加のコンテキストを提供したり、フォーカスをリダイレクトしたり、具体的な指示を与えるために使用します。",
        "interjectPlaceholder": "例：映画のみに集中し、シリーズは今はスキップ...",
        "sendInterject": "送信",
        "interjectSuccess": "AIエージェントにメッセージが正常に送信されました",
        "pauseSuccess": "監査が正常に一時停止されました",
        "resumeSuccess": "監査が正常に再開されました",
        "cancelSuccess": "監査が正常にキャンセルされました"
      },
      "progress": {
        "batch": "バッチ {{current}} / {{total}}",
        "items": "{{processed}} / {{total}} アイテム",
        "finishing": "完了処理中...",
        "finalizing": "レポートを生成し修正を適用中"
      },
      "activityLog": {
        "title": "アクティビティログ",
        "subtitle": "{{count}}件のアクションが記録されました",
        "filterByType": "タイプでフィルター",
        "allActions": "すべてのアクション",
        "content": "コンテンツ",
        "noDescription": "説明がありません",
        "updatedFields": "{{fields}}を更新しました",
        "pagination": "ページ {{page}} / {{totalPages}}",
        "issueType": "問題タイプ",
        "confidence": "信頼度",
        "autoApproved": "自動承認",
        "changes": "変更",
        "actionTypes": {
          "addPoster": "ポスターを追加",
          "updateMetadata": "メタデータを更新",
          "recategorize": "再分類",
          "fixUrl": "URLを修正",
          "cleanTitle": "タイトルをクリーン",
          "classify": "分類"
        },
        "rollback": "ロールバック",
        "rolledBack": "ロールバック済み",
        "confirmRollback": {
          "title": "ロールバックを確認",
          "message": "このアクションをロールバックしてもよろしいですか？以前の状態に復元されます。"
        },
        "emptyMessage": "アクションが見つかりません"
      },
      "modal": {
        "confirmAI": {
          "title": "AIエージェント監査を開始しますか？",
          "message": "予算制限${{budget}}で自律型AIエージェント監査を開始します。エージェントがチェックと修正について判断を行います。{{dryRun}}",
          "dryRunNote": "ドライランモードで実行（変更は行われません）。"
        },
        "cancel": "キャンセル",
        "confirm": "確認",
        "close": "閉じる",
        "retry": "再試行"
      },
      "status": {
        "enabled": "有効",
        "disabled": "無効",
        "completed": "監査完了",
        "failed": "監査失敗",
        "in_progress": "進行中",
        "partial": "部分的に完了",
        "pending": "保留中",
        "running": "実行中"
      },
      "auditTypes": {
        "daily_incremental": "デイリーインクリメンタル",
        "ai_agent": "AIエージェント"
      }
    },
    "widgets": {
      "title": "ウィジェット",
      "subtitle": "ライブストリームと埋め込み用のフローティングオーバーレイウィジェットを管理",
      "newWidget": "新規ウィジェット",
      "editWidget": "ウィジェットを編集",
      "columns": {
        "title": "タイトル",
        "contentType": "コンテンツタイプ",
        "targetRoles": "対象ロール",
        "targetPages": "対象ページ",
        "status": "ステータス",
        "order": "順序"
      },
      "contentTypes": {
        "liveChannel": "ライブチャンネル",
        "live": "ライブ",
        "vod": "ビデオオンデマンド",
        "podcast": "ポッドキャスト",
        "radio": "ラジオ",
        "iframe": "Iframe"
      },
      "status": {
        "active": "有効",
        "inactive": "無効"
      },
      "form": {
        "title": "ウィジェットタイトル",
        "description": "説明（オプション）",
        "icon": "アイコン絵文字（オプション）",
        "contentType": "コンテンツタイプ",
        "selectChannel": "ライブチャンネルを選択",
        "channelPlaceholder": "-- チャンネルを選択 --",
        "iframeUrl": "Iframe URL",
        "iframeTitle": "Iframeタイトル（アクセシビリティ用）",
        "position": "デフォルト位置",
        "behavior": "動作",
        "mutedByDefault": "デフォルトでミュート",
        "closable": "閉じることが可能",
        "draggable": "ドラッグ可能",
        "targetPages": "対象ページ（カンマ区切り、空=すべて）",
        "targetPagesPlaceholder": "/, /live, /vod",
        "order": "順序"
      },
      "actions": {
        "save": "保存",
        "cancel": "キャンセル"
      },
      "confirmDelete": "このウィジェットを削除してもよろしいですか？",
      "emptyMessage": "ウィジェットが見つかりません。作成を始めましょう。",
      "allPages": "すべてのページ",
      "allRoles": "すべて",
      "errors": {
        "titleRequired": "タイトルは必須です",
        "selectChannel": "ライブチャンネルを選択してください",
        "iframeUrlRequired": "Iframe URLは必須です"
      }
    },
    "billing": {
      "subtitle": "収益と支払いを追跡",
      "revenue": "収益",
      "today": "今日",
      "thisWeek": "今週",
      "thisMonth": "今月",
      "thisYear": "今年",
      "metrics": "主要指標",
      "totalTransactions": "総取引数",
      "avgTransaction": "平均取引額",
      "pendingRefunds": "保留中の返金",
      "refundRate": "返金率",
      "retention": "リテンション",
      "retentionRate": "リテンション率",
      "churnRate": "解約率",
      "atRiskUsers": "リスクユーザー",
      "churnedUsers": "解約ユーザー",
      "quickLinks": "クイックリンク"
    },
    "marketing": {
      "recentCampaigns": "最近のキャンペーン",
      "audienceSegments": "オーディエンスセグメント",
      "emailMetrics": "メール指標",
      "pushMetrics": "プッシュ指標",
      "quickActions": "クイックアクション"
    },
    "push": {
      "titlePlaceholder": "通知タイトル",
      "bodyPlaceholder": "通知メッセージ"
    },
    "auditLogs": {
      "subtitle": "すべてのシステムアクションを追跡",
      "filter": "フィルター",
      "export": "エクスポート",
      "all": "すべて",
      "advancedFiltering": "高度なフィルタリング",
      "actionType": "アクションタイプ",
      "clear": "クリア",
      "apply": "適用",
      "noRecords": "レコードが見つかりません",
      "columns": {
        "action": "アクション",
        "user": "ユーザー",
        "resource": "リソース",
        "details": "詳細",
        "date": "日付",
        "ip": "IP"
      },
      "changed": "変更",
      "actionFilters": {
        "user": "ユーザー",
        "subscription": "サブスクリプション",
        "payment": "支払い",
        "settings": "設定",
        "campaign": "キャンペーン",
        "content": "コンテンツ"
      }
    },
    "settings": {
      "subtitle": "システムパラメータを設定",
      "saveChanges": "変更を保存",
      "generalSettings": "一般設定",
      "supportEmail": "サポートメール",
      "defaultPlan": "デフォルトプラン",
      "termsUrl": "利用規約URL",
      "privacyUrl": "プライバシーポリシーURL",
      "userSettings": "ユーザー設定",
      "maxDevices": "アカウントあたりの最大デバイス数",
      "trialDays": "トライアル期間日数",
      "maintenanceMode": "メンテナンスモード",
      "maintenanceModeDesc": "有効にすると、ユーザーはシステムにアクセスできなくなります",
      "featureFlags": "機能フラグ",
      "systemActions": "システムアクション",
      "clearCache": "キャッシュをクリア",
      "resetAnalytics": "分析をリセット",
      "actionsWarning": "これらのアクションはシステムパフォーマンスに影響する可能性があります。注意して使用してください。",
      "savingSuccess": "設定が正常に保存されました",
      "confirmClearCache": "キャッシュをクリアしますか？一時的にパフォーマンスに影響する可能性があります。",
      "cacheCleared": "キャッシュが正常にクリアされました",
      "confirmResetAnalytics": "分析データをリセットしますか？この操作は元に戻せません！",
      "analyticsReset": "分析データがリセットされました",
      "featureFlagLabels": {
        "new_player": "新プレイヤー",
        "live_chat": "ライブチャット",
        "downloads": "ダウンロード",
        "watch_party": "ウォッチパーティー",
        "voice_search": "音声検索",
        "ai_recommendations": "AIレコメンデーション"
      }
    },
    "content": {
      "title": "コンテンツライブラリ",
      "subtitle": "映画、シリーズ、ビデオコンテンツを管理",
      "importFree": "無料コンテンツをインポート",
      "searchPlaceholder": "コンテンツを検索...",
      "emptyMessage": "コンテンツが見つかりません",
      "confirmDelete": "このコンテンツを削除しますか？",
      "confirmBatchDelete": "{{count}}件のアイテムを削除してもよろしいですか？",
      "selectedItems": "{{count}}件のアイテムが選択されています",
      "batchFeature": "おすすめに追加",
      "batchUnfeature": "おすすめから削除",
      "import": {
        "pageTitle": "無料コンテンツをインポート",
        "subtitle": "無料ソースから公開コンテンツを閲覧してインポート",
        "selectCategory": "インポートする映画のカテゴリを選択：",
        "categoryPlaceholder": "カテゴリを選択...",
        "loading": "ソースを読み込み中...",
        "sourceTypes": {
          "vod": "映画＆VOD",
          "live_tv": "ライブTV",
          "radio": "ラジオ",
          "podcasts": "ポッドキャスト"
        },
        "items": "アイテム",
        "itemsPlural": "アイテム",
        "selectItems": "インポートするアイテムを少なくとも1つ選択してください",
        "selectCategory_vod": "VODインポートのカテゴリを選択してください",
        "importing": "{{count}}件をインポート中... {{percent}}%",
        "importButton": "{{count}} {{item}}をインポート",
        "noSources": "ソースがありません",
        "noSourcesDescription": "{{type}}で利用可能な無料コンテンツソースは現在ありません"
      },
      "filters": {
        "title": "フィルター",
        "contentType": "コンテンツタイプ",
        "all": "すべて",
        "allContent": "すべて",
        "series": "シリーズ",
        "movies": "映画",
        "podcasts": "ポッドキャスト",
        "radioStations": "ラジオ局",
        "status": "ステータス",
        "allStatus": "すべてのステータス",
        "subtitles": "字幕"
      },
      "podcastsComingSoon": "ポッドキャスト管理は近日公開予定です。ポッドキャストセクションをご利用ください。",
      "radioComingSoon": "ラジオ局管理は近日公開予定です。ラジオ局セクションをご利用ください。",
      "showOnlyWithSubtitles": "字幕付きのみ表示",
      "status": {
        "published": "公開済み",
        "draft": "下書き"
      },
      "columns": {
        "title": "タイトル",
        "category": "カテゴリ",
        "year": "年",
        "status": "ステータス",
        "views": "視聴数",
        "rating": "評価",
        "streamUrl": "ストリームURL",
        "epgSource": "EPGソース",
        "genre": "ジャンル",
        "episodeNumber": "エピソード番号",
        "description": "説明",
        "duration": "再生時間",
        "publishedDate": "公開日",
        "episodes": "エピソード",
        "order": "順序",
        "name": "名前",
        "slug": "スラッグ",
        "subtitles": "字幕"
      },
      "validation": {
        "titleRequired": "タイトルは必須です",
        "nameRequired": "名前は必須です",
        "streamUrlRequired": "ストリームURLは必須です",
        "audioUrlRequired": "オーディオURLは必須です"
      },
      "episodes_one": "エピソード",
      "episodes_other": "エピソード",
      "noEpisodes": "エピソードが見つかりません",
      "type": {
        "series": "シリーズ",
        "movie": "映画"
      },
      "toggleCarousel": "カルーセルを切り替え",
      "editor": {
        "pageTitle": "コンテンツを編集",
        "pageTitleNew": "コンテンツを追加",
        "sections": {
          "basicInfo": "基本情報",
          "media": "メディア",
          "streaming": "ストリーミング",
          "details": "コンテンツ詳細",
          "publishing": "公開",
          "accessControl": "アクセス制御",
          "podcastDetails": "ポッドキャスト詳細",
          "episodeDetails": "エピソード詳細",
          "stationDetails": "ステーション詳細",
          "channelDetails": "チャンネル詳細"
        },
        "fields": {
          "title": "タイトル",
          "titlePlaceholder": "コンテンツタイトル",
          "titleRequired": "タイトルは必須です",
          "year": "年",
          "yearPlaceholder": "2024",
          "description": "説明",
          "descriptionPlaceholder": "コンテンツの説明",
          "thumbnail": "サムネイル（3:4アスペクト比）",
          "thumbnailUrl": "サムネイルURL",
          "thumbnailUrlPlaceholder": "https://example.com/thumbnail.jpg",
          "backdrop": "背景（16:9アスペクト比）",
          "backdropUrl": "背景URL",
          "posterCover": "ポッドキャストカバー",
          "logo": "ロゴ",
          "channelLogo": "チャンネルロゴ",
          "stationLogo": "ステーションロゴ",
          "streamUrl": "ストリームURL",
          "streamUrlRequired": "ストリームURLは必須です",
          "streamType": "ストリームタイプ",
          "drmProtected": "DRM保護",
          "drmProtectedLabel": "このコンテンツにはDRM保護が必要です",
          "category": "カテゴリ",
          "categoryRequired": "カテゴリは必須です",
          "duration": "再生時間",
          "durationPlaceholder": "1:30:00",
          "rating": "評価",
          "ratingPlaceholder": "PG-13",
          "genre": "ジャンル",
          "genrePlaceholder": "ドラマ",
          "director": "監督",
          "directorPlaceholder": "監督名",
          "isSeries": "シリーズ",
          "isSeriesLabel": "これはシリーズ/複数パートのコンテンツです",
          "season": "シーズン",
          "episode": "エピソード",
          "seriesId": "シリーズID",
          "seriesIdPlaceholder": "series-identifier",
          "isPublished": "公開",
          "isPublishedLabel": "このコンテンツをすぐに公開",
          "isFeatured": "おすすめ",
          "isFeaturedLabel": "このコンテンツをホームページでおすすめ表示",
          "requiresSubscription": "必要なサブスクリプション",
          "isKidsContent": "キッズコンテンツ",
          "isKidsContentLabel": "これはキッズ向けコンテンツです",
          "author": "著者",
          "authorPlaceholder": "ポッドキャスト著者",
          "podcastCategory": "カテゴリ",
          "podcastCategoryPlaceholder": "ニュース、科学など",
          "rssFeed": "RSSフィードURL",
          "rssFeedPlaceholder": "https://example.com/feed.xml",
          "website": "ウェブサイトURL",
          "websitePlaceholder": "https://example.com",
          "episodeNumber": "エピソード番号",
          "seasonNumber": "シーズン番号",
          "audioUrl": "オーディオURL",
          "audioUrlRequired": "オーディオURLは必須です",
          "audioUrlPlaceholder": "https://example.com/episode.mp3",
          "publishedAt": "公開日",
          "epgSource": "EPGソースURL",
          "epgSourcePlaceholder": "https://example.com/epg.xml",
          "currentShow": "現在の番組",
          "currentShowPlaceholder": "番組名",
          "nextShow": "次の番組",
          "nextShowPlaceholder": "番組名",
          "currentSong": "現在の曲",
          "currentSongPlaceholder": "曲タイトル",
          "isActive": "アクティブ",
          "isActiveLabel": "チャンネルはアクティブ",
          "requiredSubscription": "必要なサブスクリプション",
          "publishedDate": "公開日"
        },
        "subscriptionTiers": {
          "basic": "ベーシック",
          "premium": "プレミアム",
          "family": "ファミリー"
        },
        "actions": {
          "save": "保存",
          "saving": "保存中...",
          "cancel": "キャンセル"
        },
        "imageUpload": {
          "dropHere": "ここに画像をドロップまたはクリックしてアップロード",
          "formats": "PNG、JPG、WebP 最大{{maxSize}}MB",
          "uploading": "アップロード中...",
          "success": "画像が正常にアップロードされました",
          "orPasteUrl": "または画像URLを貼り付け",
          "urlPlaceholder": "https://example.com/image.jpg",
          "validateButton": "追加",
          "validating": "検証中...",
          "clear": "画像を削除",
          "errors": {
            "imageOnly": "画像ファイルを選択してください",
            "tooLarge": "ファイルサイズは{{maxSize}}MB未満にしてください",
            "uploadFailed": "アップロードに失敗しました",
            "invalidUrl": "無効なURL"
          }
        }
      },
      "categoryPicker": {
        "selectPlaceholder": "カテゴリを選択...",
        "searchPlaceholder": "カテゴリを検索...",
        "loading": "カテゴリを読み込み中...",
        "noResults": "カテゴリが見つかりません",
        "noCategories": "利用可能なカテゴリがありません",
        "createNew": "新しいカテゴリを作成",
        "errors": {
          "loadFailed": "カテゴリの読み込みに失敗しました",
          "createFailed": "カテゴリの作成に失敗しました"
        },
        "modal": {
          "title": "新しいカテゴリを作成",
          "placeholder": "カテゴリ名（例：映画、シリーズ）",
          "creating": "作成中...",
          "create": "作成"
        }
      },
      "streamUrlInput": {
        "copyUrl": "URLをコピー",
        "copied": "URLがクリップボードにコピーされました",
        "streamType": "ストリームタイプ",
        "validUrl": "URLは有効です - {{type}}として検出されました",
        "errors": {
          "required": "ストリームURLは必須です",
          "invalidFormat": "無効なURL形式"
        },
        "supportedFormats": {
          "title": "対応フォーマット：",
          "hls": "HLS：.m3u8ストリーム",
          "dash": "DASH：.mpdストリーム",
          "audio": "オーディオ：.mp3、.aac、またはオーディオストリーム"
        }
      }
    },
    "categories": {
      "subtitle": "コンテンツカテゴリを管理",
      "emptyMessage": "カテゴリが見つかりません",
      "status": {
        "active": "有効",
        "inactive": "無効"
      },
      "form": {
        "nameHebrew": "カテゴリ名（ヘブライ語）",
        "nameEnglish": "カテゴリ名（英語）",
        "slug": "スラッグ"
      }
    },
    "liveChannels": {
      "subtitle": "ライブTVチャンネルを管理",
      "emptyMessage": "ライブチャンネルが見つかりません",
      "subtitleSettings": "ライブ字幕設定",
      "form": {
        "name": "チャンネル名",
        "streamUrl": "ストリームURL",
        "epgSource": "EPGソースURL（オプション）",
        "currentShow": "現在の番組",
        "order": "順序",
        "supportsSubtitles": "ライブ字幕を有効化",
        "primaryLanguage": "主言語（ソース）",
        "targetLanguages": "利用可能な翻訳言語",
        "targetLanguagesHelp": "ユーザーがリアルタイムで翻訳できる言語を選択"
      }
    },
    "radioStations": {
      "subtitle": "ラジオ局を管理",
      "emptyMessage": "ラジオ局が見つかりません",
      "form": {
        "name": "局名",
        "genre": "ジャンル",
        "streamUrl": "ストリームURL",
        "currentShow": "現在の番組（オプション）",
        "currentSong": "現在の曲（オプション）",
        "order": "順序"
      }
    },
    "podcasts": {
      "subtitle": "ポッドキャストとエピソードを管理",
      "episodesSubtitle": "エピソードを管理",
      "emptyMessage": "ポッドキャストが見つかりません",
      "noEpisodes": "エピソードが見つかりません",
      "form": {
        "title": "ポッドキャストタイトル",
        "author": "著者",
        "description": "説明",
        "category": "カテゴリ",
        "rssFeed": "RSSフィードURL",
        "website": "ウェブサイトURL（オプション）"
      },
      "episodes": {
        "form": {
          "title": "エピソードタイトル",
          "description": "説明",
          "episodeNumber": "エピソード番号",
          "seasonNumber": "シーズン番号（オプション）",
          "duration": "再生時間",
          "audioUrl": "オーディオURL（必須）",
          "publishedDate": "公開日（YYYY-MM-DD）"
        }
      }
    },
    "users": {
      "subtitle": "ユーザーとアカウントを管理",
      "addUser": "ユーザーを追加",
      "status": {
        "active": "有効",
        "inactive": "無効",
        "blocked": "ブロック済み"
      },
      "filters": {
        "all": "すべて",
        "active": "有効",
        "inactive": "無効",
        "blocked": "ブロック済み"
      },
      "columns": {
        "name": "名前",
        "role": "権限",
        "subscription": "サブスクリプション",
        "noSubscription": "サブスクリプションなし",
        "status": "ステータス",
        "created": "作成日",
        "actions": "アクション"
      },
      "confirmDelete": "ユーザーを削除",
      "confirmDeleteMessage": "{{name}}を削除してもよろしいですか？この操作は元に戻せません。",
      "resetPassword": "パスワードをリセット",
      "block": "ブロック",
      "unban": "ブロック解除",
      "confirmResetPassword": "{{email}}にパスワードリセットメールを送信しますか？",
      "resetPasswordSent": "パスワードリセットメールが送信されました",
      "recentActivity": "最近のアクティビティ",
      "noActivity": "アクティビティなし",
      "notFound": "ユーザーが見つかりません",
      "backToList": "一覧に戻る",
      "banReason": "ブロック理由",
      "banReasonPrompt": "ブロック理由：",
      "confirmUnban": "ユーザーのブロックを解除しますか？",
      "userDetails": "ユーザー詳細",
      "id": "ID",
      "registered": "登録日",
      "billingHistory": "請求履歴",
      "noPayments": "支払いなし"
    },
    "campaigns": {
      "subtitle": "クーポンコードと割引を管理",
      "expired": "期限切れ",
      "status": {
        "active": "有効",
        "inactive": "無効"
      },
      "columns": {
        "name": "名前",
        "discount": "割引",
        "usage": "使用回数",
        "validUntil": "有効期限",
        "status": "ステータス",
        "actions": "アクション"
      },
      "confirmDelete": "キャンペーンを削除",
      "confirmDeleteMessage": "「{{name}}」を削除してもよろしいですか？この操作は元に戻せません。",
      "searchPlaceholder": "キャンペーンを検索...",
      "emptyMessage": "キャンペーンが見つかりません",
      "deactivate": "無効化",
      "activate": "有効化",
      "createTitle": "新規キャンペーン",
      "editTitle": "キャンペーンを編集",
      "formSubtitle": "クーポンコードまたは割引を設定",
      "form": {
        "name": "キャンペーン名",
        "namePlaceholder": "例：サマーセール2024",
        "code": "クーポンコード",
        "generate": "生成",
        "discountType": "割引タイプ",
        "discountValue": "割引値",
        "maxUses": "最大使用回数",
        "unlimited": "無制限",
        "validUntil": "有効期限",
        "active": "キャンペーン有効"
      }
    },
    "subscriptions": {
      "subtitle": "システムの登録者を表示・管理",
      "status": {
        "active": "有効",
        "paused": "一時停止",
        "cancelled": "キャンセル",
        "expired": "期限切れ"
      },
      "columns": {
        "user": "ユーザー",
        "plan": "プラン",
        "price": "価格",
        "nextBilling": "次回請求日",
        "status": "ステータス"
      },
      "perMonth": "/月",
      "searchPlaceholder": "サブスクリプションを検索...",
      "emptyMessage": "サブスクリプションが見つかりません",
      "actions": {
        "changePlan": "プランを変更",
        "pause": "一時停止",
        "resume": "再開",
        "cancel": "キャンセル",
        "delete": "削除"
      },
      "editPlan": {
        "title": "サブスクリプションプランを変更",
        "user": "ユーザー",
        "currentPlan": "現在のプラン",
        "newPlan": "新しいプランを選択"
      },
      "addSubscription": {
        "title": "サブスクリプションを追加",
        "userEmail": "ユーザーメール",
        "emailPlaceholder": "ユーザーメールを入力",
        "duration": "期間（日数）",
        "selectPlan": "プランを選択"
      },
      "fillAllFields": "すべての項目を入力してください",
      "userNotFound": "ユーザーが見つかりません",
      "selectOneToEdit": "編集するサブスクリプションを1つ選択してください",
      "selectToDelete": "削除するサブスクリプションを選択してください",
      "confirmDeleteMultiple": "{{count}}件のサブスクリプションを削除しますか？",
      "selected": "選択済み",
      "confirmDelete": "{{user}}のサブスクリプションを削除してもよろしいですか？この操作は元に戻せません。"
    },
    "marketingDashboard": {
      "subtitle": "マーケティング概要",
      "refresh": "更新",
      "totalSubscribers": "総登録者数",
      "emailOpenRate": "メール開封率",
      "pushClickRate": "プッシュクリック率",
      "activeSegments": "アクティブセグメント",
      "campaignStatus": {
        "active": "有効",
        "completed": "完了",
        "scheduled": "予定",
        "draft": "下書き"
      }
    },
    "transactions": {
      "subtitle": "支払い履歴を表示",
      "exportCsv": "CSVエクスポート",
      "status": {
        "completed": "完了",
        "pending": "保留中",
        "failed": "失敗",
        "refunded": "返金済み"
      },
      "columns": {
        "id": "ID",
        "user": "ユーザー",
        "amount": "金額",
        "type": "タイプ",
        "status": "ステータス",
        "date": "日付"
      },
      "filters": {
        "all": "すべて"
      },
      "searchPlaceholder": "取引を検索...",
      "emptyMessage": "取引が見つかりません",
      "details": "取引詳細",
      "email": "メール"
    },
    "pushNotifications": {
      "subtitle": "ユーザーへの通知を作成・送信",
      "newNotification": "新規通知",
      "status": {
        "draft": "下書き",
        "sent": "送信済み",
        "scheduled": "予定"
      },
      "columns": {
        "title": "タイトル",
        "status": "ステータス",
        "sent": "送信数",
        "opened": "開封数",
        "scheduledAt": "予定日時",
        "created": "作成日",
        "actions": "アクション"
      },
      "filters": {
        "all": "すべて"
      },
      "searchPlaceholder": "通知を検索...",
      "emptyMessage": "通知が見つかりません",
      "createModal": "新規プッシュ通知",
      "editModal": "通知を編集",
      "scheduleModal": "通知をスケジュール",
      "titleLabel": "タイトル",
      "bodyLabel": "本文",
      "dateTimeLabel": "日時",
      "cancel": "キャンセル",
      "create": "通知を作成",
      "schedule": "スケジュール",
      "send": "今すぐ送信",
      "confirmSend": "通知「{{title}}」を送信しますか？",
      "confirmDelete": "通知「{{title}}」を削除しますか？",
      "fillRequired": "タイトルと本文を入力してください"
    }
  },
  "placeholder": {
    "email": "[ja] your@email.com",
    "password": "[ja] ••••••••",
    "pin": "[ja] ••••",
    "dateRange": {
      "from": "[ja] From (YYYY-MM-DD)",
      "to": "[ja] To (YYYY-MM-DD)"
    },
    "amount": {
      "min": "[ja] Min",
      "max": "[ja] Max",
      "price": "[ja] 0.00"
    },
    "chatMessage": "[ja] Type here...",
    "deepLink": "[ja] bayitplus://content/123",
    "scheduleDateTime": "[ja] YYYY-MM-DDTHH:mm",
    "roomCode": "[ja] ABCD1234",
    "time": {
      "start": "[ja] 08:00",
      "end": "[ja] 10:00"
    },
    "filter": {
      "userId": "[ja] Enter user ID"
    },
    "datetime": "[ja] YYYY-MM-DDTHH:mm",
    "number": "[ja] 0",
    "chat": "[ja] Type your message..."
  },
  "components": {
    "select": {
      "default": "[ja] Select..."
    }
  },
  "plans": {
    "basic": {
      "name": "[ja] Basic",
      "features": "[ja] ['All VOD content', 'Radio & Podcasts', 'Watch on 1 device', 'SD quality']",
      "notIncluded": "[ja] ['Live channels', 'AI Assistant', 'Offline viewing']"
    },
    "premium": {
      "name": "[ja] Premium",
      "features": "[ja] ['All VOD content', 'Live channels', 'Radio & Podcasts', 'Smart AI Assistant', 'Watch on 2 devices', 'HD quality']",
      "notIncluded": "[ja] ['Offline viewing', 'Family profiles']"
    },
    "family": {
      "name": "[ja] Family",
      "features": "[ja] ['All VOD content', 'Live channels', 'Radio & Podcasts', 'Smart AI Assistant', 'Watch on 4 devices', '4K quality', '5 family profiles', 'Download for offline']",
      "notIncluded": "[ja] []"
    },
    "batchActions": {
      "selectedCount": "[ja] {{count}} selected",
      "selectedCount_one": "[ja] {{count}} selected",
      "selectedCount_other": "[ja] {{count}} selected",
      "clear": "[ja] Clear"
    },
    "costDashboard": {
      "title": "[ja] Cost Dashboard",
      "costBreakdown": "[ja] Cost Breakdown",
      "loadingBreakdown": "[ja] Loading breakdown...",
      "aiCosts": "[ja] AI Costs",
      "infrastructure": "[ja] Infrastructure",
      "thirdParty": "[ja] Third-party",
      "thirdPartyApis": "[ja] Third-party APIs",
      "translation": "[ja] Translation",
      "search": "[ja] Search",
      "percentOfTotal": "[ja] % of total",
      "components": "[ja] Components",
      "topSpenders": {
        "title": "[ja] Top 20 Spenders (Monthly)",
        "loading": "[ja] Loading top spenders...",
        "rank": "[ja] Rank",
        "userId": "[ja] User ID",
        "costRange": "[ja] Cost Range",
        "privacyNote": "[ja] User IDs are hashed and costs are aggregated into ranges for privacy protection."
      },
      "categories": {
        "permanent": "[ja] Permanent",
        "transient": "[ja] Transient",
        "permanentVsTransient": "[ja] Permanent vs Transient",
        "permanentFixed": "[ja] Permanent (Fixed)",
        "transientVariable": "[ja] Transient (Variable)",
        "permanentDesc": "[ja] Infrastructure costs that occur monthly regardless of usage",
        "transientDesc": "[ja] Usage-based costs that fluctuate with platform activity",
        "detailedBreakdown": "[ja] Detailed Breakdown",
        "costItem": "[ja] Cost Item",
        "category": "[ja] Category",
        "amount": "[ja] Amount"
      },
      "timeline": {
        "title": "[ja] Cost Timeline",
        "loading": "[ja] Loading timeline...",
        "amountLabel": "[ja] Amount ($)",
        "revenue": "[ja] Revenue",
        "totalCost": "[ja] Total Cost",
        "netProfit": "[ja] Net Profit",
        "showingData": "[ja] Showing data from {{start}} to {{end}}"
      },
      "plSummary": {
        "netProfitLoss": "[ja] Net Profit/Loss",
        "margin": "[ja] margin",
        "revenue": "[ja] REVENUE",
        "totalCosts": "[ja] TOTAL COSTS"
      }
    }
  },
  "subscribe": {
    "title": "サブスクリプション",
    "subtitle": "プランを選択",
    "monthly": "月額",
    "yearly": "年額",
    "save2Months": "[ja] Save 2 months",
    "popular": "[ja] Most Popular",
    "period": "[ja] /month",
    "perYear": "/年",
    "select": "[ja] Select Plan",
    "selected": "[ja] Selected",
    "processing": "処理中...",
    "startTrial": "トライアルを開始",
    "noCharge": "[ja] Your credit card won't be charged during the trial period"
  },
  "notFound": {
    "title": "ページが見つかりません",
    "description": "[ja] The page you're looking for doesn't exist or has been moved.",
    "homeButton": "[ja] Go Home",
    "searchButton": "[ja] Search",
    "orTry": "[ja] Or try:",
    "liveChannel": "[ja] Live",
    "vodLabel": "[ja] Movies",
    "podcastsLabel": "[ja] Podcasts"
  },
  "profiles": {
    "addProfile": "[ja] Add Profile",
    "enterPin": "[ja] Enter PIN",
    "selectError": "[ja] Error selecting profile",
    "wrongPin": "[ja] Incorrect PIN",
    "loading": "[ja] Loading profiles...",
    "manage": "[ja] Manage Profiles",
    "whoIsWatching": "[ja] Who's Watching?",
    "manageProfiles": "[ja] Manage Profiles",
    "kids": "キッズ",
    "addIcon": "+"
  },
  "watch": {
    "notFound": "[ja] Content not found",
    "backToHome": "[ja] Back to Home",
    "episodes": "[ja] Episodes",
    "addToList": "[ja] Add to List",
    "like": "[ja] Like",
    "share": "[ja] Share",
    "cast": "[ja] Cast",
    "episodesList": "[ja] Episodes",
    "schedule": "[ja] Schedule",
    "now": "[ja] Now",
    "related": "[ja] Related Content",
    "deleteEpisode": "[ja] Delete Episode",
    "confirmDeleteEpisode": "[ja] Delete this episode?"
  },
  "live": {
    "title": "[ja] Live TV",
    "next": "[ja] Next:",
    "noChannels": "[ja] No channels available",
    "tryLater": "[ja] Try again later",
    "categories": {
      "all": "[ja] All",
      "news": "[ja] News",
      "entertainment": "[ja] Entertainment",
      "sports": "[ja] Sports",
      "kids": "[ja] Kids",
      "music": "[ja] Music"
    }
  },
  "judaism": {
    "title": "ユダヤ教",
    "items": "[ja] items",
    "empty": "[ja] No content available",
    "emptyHint": "[ja] Try selecting another category",
    "dashboard": "[ja] Your Jewish Dashboard",
    "categories": {
      "news": "[ja] Jewish News",
      "community": "[ja] Community"
    },
    "shabbat": {
      "title": "[ja] Shabbat Times",
      "shabbatShalom": "[ja] Shabbat Shalom!",
      "shabbatMode": "[ja] Shabbat Mode",
      "endsIn": "[ja] Shabbat ends in",
      "candleLighting": "[ja] Candle Lighting",
      "havdalah": "[ja] Havdalah",
      "parashat": "[ja] Parashat",
      "friday": "[ja] Friday",
      "saturday": "[ja] Saturday",
      "noData": "[ja] Unable to load Shabbat times"
    },
    "erevShabbat": {
      "title": "[ja] Erev Shabbat",
      "prepareFor": "[ja] Prepare for Shabbat",
      "inTime": "[ja] in {{time}}",
      "featuredContent": "[ja] Shabbat Content",
      "noContent": "[ja] Shabbat content coming soon!",
      "shabbatShalom": "[ja] Shabbat Shalom!",
      "timeUntil": "[ja] Time until Shabbat",
      "shabbatSongs": "[ja] Shabbat Songs",
      "parashaStudy": "[ja] Parasha",
      "shabbatRecipes": "[ja] Recipes",
      "prayers": "[ja] Prayers"
    }
  },
  "children": {
    "title": "キッズ",
    "items": "[ja] items",
    "empty": "[ja] No content available",
    "emptyHint": "[ja] Try another category",
    "exitKidsMode": "キッズモードを終了",
    "exitDescription": "[ja] Enter parent code to exit",
    "parentCode": "[ja] Parent code",
    "confirm": "[ja] Confirm",
    "wrongCode": "[ja] Incorrect code",
    "noContent": "[ja] No content available",
    "tryAnotherCategory": "[ja] Try selecting another category",
    "categories": {
      "all": "[ja] All",
      "cartoons": "[ja] Cartoons",
      "educational": "[ja] Educational",
      "music": "[ja] Music",
      "hebrew": "[ja] Hebrew",
      "stories": "[ja] Stories",
      "jewish": "[ja] Jewish"
    },
    "ageRatings": {
      "3": "[ja] Ages 3+",
      "5": "[ja] Ages 5+",
      "7": "[ja] Ages 7+",
      "10": "[ja] Ages 10+",
      "12": "[ja] Ages 12+"
    },
    "moderation": {
      "pending": "[ja] Pending Review",
      "approved": "[ja] Approved",
      "rejected": "[ja] Rejected"
    },
    "admin": {
      "stats": "[ja] Kids Content Manager",
      "seedContent": "[ja] Seed Content",
      "importArchive": "[ja] Import Archive.org",
      "syncPodcasts": "[ja] Sync Podcasts",
      "syncYouTube": "[ja] Sync YouTube",
      "tagVod": "[ja] Tag VOD",
      "pendingModeration": "[ja] Pending Moderation"
    }
  },
  "youngsters": {
    "title": "[ja] Youngsters",
    "items": "[ja] items",
    "empty": "[ja] No content available",
    "emptyHint": "[ja] Try another category",
    "exitYoungstersMode": "[ja] Exit Youngsters Mode",
    "exitDescription": "[ja] Enter parent code to exit",
    "parentCode": "[ja] Parent code",
    "confirm": "[ja] Confirm",
    "wrongCode": "[ja] Incorrect code",
    "noContent": "[ja] No content available",
    "tryAnotherCategory": "[ja] Try selecting another category",
    "categories": {
      "all": "[ja] All",
      "trending": "[ja] Trending",
      "news": "[ja] News",
      "culture": "[ja] Culture",
      "educational": "[ja] Educational",
      "music": "[ja] Music",
      "entertainment": "[ja] Entertainment",
      "sports": "[ja] Sports",
      "tech": "[ja] Technology",
      "judaism": "[ja] Judaism"
    },
    "ageGroups": {
      "middle-school": "[ja] Middle School (12-14)",
      "high-school": "[ja] High School (15-17)"
    },
    "moderation": {
      "pending": "[ja] Pending Review",
      "approved": "[ja] Approved",
      "rejected": "[ja] Rejected"
    },
    "admin": {
      "stats": "[ja] Youngsters Content Manager",
      "seedContent": "[ja] Seed Content",
      "importArchive": "[ja] Import Archive.org",
      "syncPodcasts": "[ja] Sync Podcasts",
      "syncYouTube": "[ja] Sync YouTube",
      "tagVod": "[ja] Tag VOD",
      "pendingModeration": "[ja] Pending Moderation"
    }
  },
  "chatbot": {
    "title": "アシスタント",
    "greeting": "[ja] Hello! I'm Bayit+ smart assistant. How can I help you today? Click the microphone and speak, or type a message.",
    "openChat": "[ja] Open chat",
    "welcome": "ようこそ！今日は何をお手伝いしましょうか？",
    "placeholder": "メッセージを入力...",
    "recording": "[ja] Recording... click again to stop",
    "transcribing": "[ja] Transcribing...",
    "stopRecording": "[ja] Stop recording",
    "startRecording": "[ja] Start voice recording",
    "recommendations": "[ja] Here are some recommendations:",
    "showMultipleSuccess": "[ja] Showing {{count}} content items in widgets",
    "showMultipleNotFound": "[ja] Could not find the requested content. Please try different names.",
    "resolvingContent": "[ja] Finding your content...",
    "errors": {
      "micPermission": "[ja] Could not access microphone. Please check microphone permissions in your browser.",
      "transcribeFailed": "[ja] Could not transcribe the recording. Please try again.",
      "general": "[ja] Sorry, something went wrong. Please try again."
    },
    "suggestions": {
      "whatToWatch": "[ja] What to watch today?",
      "israeliMovies": "[ja] Recommended Israeli movies",
      "whatsOnNow": "[ja] What's on now?",
      "popularPodcasts": "[ja] Popular podcasts"
    },
    "voiceCommands": {
      "showChannels": "[ja] Show me channels...",
      "playChess": "[ja] Start a chess game with...",
      "multiContent": "[ja] Show side by side..."
    }
  },
  "chat": {
    "title": "[ja] Bayit+ Assistant",
    "greeting": "[ja] Hello! I'm Bayit+ smart assistant. How can I help you today? Click the microphone and speak, or type a message."
  },
  "subtitles": {
    "nikud": "ニクード",
    "selection": "選択",
    "translation": "翻訳",
    "translating": "翻訳中...",
    "close": "閉じる",
    "unavailable": "翻訳が利用できません",
    "off": "オフ",
    "none": "なし",
    "autoGenerated": "自動生成",
    "selectLanguage": "字幕言語を選択",
    "liveTranslate": "リアルタイム翻訳",
    "translateTo": "翻訳先",
    "downloadMore": "字幕をもっとダウンロード...",
    "downloading": "OpenSubtitlesを検索中...",
    "opensubtitlesSource": "OpenSubtitles.comから",
    "downloadSuccess": "{{count}}件の字幕をダウンロードしました",
    "noSubtitlesFound": "このコンテンツの字幕が見つかりません",
    "smartSubs": "スマート字幕",
    "smartSubsDescription": "デュアルビュー：簡易ヘブライ語＋語根ハイライト付き英語",
    "smartSubsDualView": "デュアルビュー",
    "shoreshToggle": "Shoreshハイライト",
    "shoreshOn": "Shoreshハイライトが有効",
    "shoreshOff": "Shoreshハイライトが無効",
    "nikudLive": "Nikud付きヘブライ語",
    "nikudLiveDescription": "読みやすくするための母音記号付きヘブライ語字幕",
    "nikudEnabled": "Nikud字幕が有効",
    "nikudDisabled": "Nikud字幕が無効",
    "nikudSubtitleLabel": "Nikud付きヘブライ語：{{text}}",
    "available": "字幕",
    "clickToEnable": "クリックしてリアルタイム翻訳を有効化",
    "connectionError": "リアルタイム翻訳エラー",
    "inputLanguageTooltip": "入力言語を確認",
    "premiumRequired": "プレミアムサブスクリプションが必要です",
    "selectInputLanguage": "入力言語を選択",
    "translateActive": "リアルタイム翻訳がアクティブ",
    "noEnglishSubtitles": "このコンテンツには英語字幕がありません。",
    "hebrewMode": {
      "title": "ヘブライ語表示モード",
      "unavailable": "利用不可",
      "generate": "生成",
      "regular": {
        "title": "通常のヘブライ語",
        "description": "母音記号なしの標準ヘブライ語テキスト"
      },
      "nikud": {
        "title": "Nikud付きヘブライ語",
        "description": "読みやすくするための母音記号付きヘブライ語",
        "unavailableReason": "このコンテンツではAI処理が利用できません"
      },
      "shoresh": {
        "title": "Shoresh（語根）",
        "description": "語根分析付きヘブライ語：単語 [語根]",
        "unavailableReason": "このコンテンツでは語根分析が利用できません"
      }
    },
    "englishMode": {
      "title": "英語表示モード",
      "unavailable": "利用不可",
      "generate": "生成",
      "firstTimeHint": "これらのAIモードは、英語の文構造を学びながらヘブライ語を維持するのに役立ちます。各モードはユニークな学習体験を提供します。",
      "regular": {
        "title": "通常の英語",
        "description": "標準の英語字幕"
      },
      "heblish": {
        "title": "ヘブリッシュ",
        "description": "没入型学習のためのヘブライ語単語が挿入された英語",
        "unavailableReason": "このコンテンツではHeblish処理が利用できません"
      },
      "grammarFlip": {
        "title": "グラマーフリップ",
        "description": "英語の文構造（主語-動詞-目的語）を持つヘブライ語単語",
        "unavailableReason": "このコンテンツではGrammar-Flip処理が利用できません"
      },
      "slangSynthesis": {
        "title": "スラング合成",
        "description": "魅力的なコンテンツのための現代イスラエルとアメリカのスラングブレンド",
        "unavailableReason": "このコンテンツではSlang Synthesis処理が利用できません"
      }
    },
    "loading": "字幕を読み込み中...",
    "error": {
      "title": "字幕エラー",
      "retry": "再試行",
      "loadFailed": "字幕の読み込みに失敗しました",
      "cuesFailed": "字幕テキストの読み込みに失敗しました",
      "networkError": "ネットワークエラー - 接続を確認してください",
      "serverError": "サーバーエラー - 後でもう一度お試しください"
    },
    "aiModesAvailable": "利用可能なAIモード",
    "aiModesTitle": "AI字幕モード",
    "fetchSubtitles": "字幕を取得",
    "fontSize": "フォントサイズ",
    "mode": {
      "engrew": "エングリュー",
      "heblish": "ヘブリッシュ",
      "shoresh": "ショレシュ",
      "standard": "スタンダード"
    },
    "opensubtitles": "OpenSubtitles",
    "searchExternal": "外部字幕を検索",
    "settingsTitle": "字幕設定",
    "showBackground": "背景を表示",
    "singleMode": "シングルモード",
    "splitMode": "分割モード",
    "primary_language": "主要言語",
    "secondary_language": "副次言語",
    "layout_mode": "レイアウトモード",
    "interactive_title": "インタラクティブ字幕"
  },
  "video": {
    "watchTrailer": "[ja] Watch Trailer",
    "closeTrailer": "[ja] Close Trailer",
    "deleteConfirm": "[ja] Delete this episode?"
  },
  "recordings": {
    "title": "録画",
    "subtitle": "録画したコンテンツ",
    "record": "[ja] Record",
    "recording": "録画中",
    "storageUsed": "[ja] Storage Used",
    "totalRecordings": "[ja] Total Recordings",
    "maxDuration": "[ja] Max Duration",
    "noRecordings": "録画がありません",
    "noRecordingsHint": "[ja] Start recording from any live channel!",
    "confirmDelete": "[ja] Are you sure you want to delete this recording? This action cannot be undone.",
    "deleteRecording": "[ja] Delete Recording",
    "deleteFailed": "[ja] Failed to delete recording",
    "expires": "[ja] Expires",
    "subtitlesAvailable": "[ja] Subtitles Available",
    "recordingSaved": "[ja] Recording Saved!",
    "savedSuccess": "[ja] Recording saved successfully! Duration: {{duration}}",
    "viewInMyRecordings": "[ja] View in My Recordings",
    "error": "[ja] Recording Error",
    "startFailed": "[ja] Failed to start recording. Please try again.",
    "stopFailed": "[ja] Failed to stop recording. Please try again.",
    "page": "[ja] Page"
  },
  "chess": {
    "title": "[ja] Chess",
    "welcome": "[ja] Welcome to Chess",
    "subtitle": "[ja] Play chess with friends and family around the world",
    "createGame": "[ja] Create New Game",
    "joinGame": "[ja] Join Game",
    "gameCode": "[ja] Game Code",
    "enterGameCode": "[ja] Enter Game Code",
    "invalidGameCode": "[ja] Invalid game code. Must be 6 characters.",
    "joinFailed": "[ja] Failed to join game",
    "join": "[ja] Join",
    "create": "[ja] Create",
    "chooseColor": "[ja] Choose Your Color",
    "white": "[ja] White",
    "black": "[ja] Black",
    "chatPlaceholder": "[ja] Type a message... (@bot for advice)",
    "botHint": "[ja] Tag @bot in your message to get chess advice from our AI assistant",
    "bot": "[ja] Chess Assistant",
    "mute": "[ja] Mute",
    "unmute": "[ja] Unmute",
    "speaking": "[ja] participants",
    "resign": "[ja] Resign",
    "offerDraw": "[ja] Offer Draw",
    "newGame": "[ja] New Game",
    "checkmate": "[ja] Checkmate!",
    "stalemate": "[ja] Stalemate",
    "draw": "[ja] Draw",
    "resigned": "[ja] Game Resigned",
    "reconnecting": "[ja] Reconnecting...",
    "moveHistory": "[ja] Move History",
    "noMoves": "[ja] No moves yet",
    "showHints": "[ja] Show Guide Hints",
    "yourTurn": "[ja] Your Turn",
    "opponentTurn": "[ja] Opponent's Turn",
    "waitingForOpponent": "[ja] Waiting for opponent...",
    "gameOver": "[ja] Game Over",
    "sendingInvite": "[ja] Sending game invite to {{name}}...",
    "inviteSent": "[ja] Game invite sent to {{name}}! Game code: {{code}}",
    "inviteFailed": "[ja] Could not find that user. Please check the name and try again.",
    "inviteReceived": "[ja] {{name}} invited you to a chess game!",
    "joinInvite": "[ja] Join Game",
    "challenge": "[ja] Challenge",
    "playedAsWhite": "[ja] Played as White",
    "playedAsBlack": "[ja] Played as Black",
    "gameMode": "[ja] Game Mode",
    "playVsFriend": "[ja] Play vs Friend",
    "playVsBot": "[ja] Play vs Bot",
    "difficulty": "[ja] Difficulty",
    "easy": "[ja] Easy",
    "medium": "[ja] Medium",
    "hard": "[ja] Hard",
    "chessBot": "[ja] Chess Bot",
    "chat": {
      "title": "[ja] Chat",
      "inputPlaceholder": "[ja] Type a message..."
    },
    "acceptDraw": "[ja] Accept Draw",
    "acceptInvite": "[ja] Accept Invite",
    "blackCaptured": "[ja] Black Captured",
    "blackTurn": "[ja] Black's Turn",
    "challengeFriend": "[ja] Challenge Friend",
    "challengeViaWhatsApp": "[ja] Challenge via WhatsApp",
    "copyCode": "[ja] Copy Code",
    "declineDraw": "[ja] Decline Draw",
    "declineInvite": "[ja] Decline Invite",
    "drawOffered": "[ja] Draw Offered",
    "joinByGameCode": "[ja] Join by Game Code",
    "noFriendsYet": "[ja] No friends yet",
    "offline": "[ja] Offline",
    "online": "[ja] Online",
    "opponent": "[ja] Opponent",
    "whiteCaptured": "[ja] White Captured",
    "whiteTurn": "[ja] White's Turn",
    "you": "[ja] You"
  },
  "friends": {
    "title": "[ja] Friends & Opponents",
    "subtitle": "[ja] Connect with players and challenge friends",
    "myFriends": "[ja] My Friends",
    "requests": "[ja] Requests",
    "findPlayers": "[ja] Find Players",
    "friendsLabel": "[ja] Friends",
    "pendingLabel": "[ja] Pending",
    "add": "[ja] Add Friend",
    "remove": "[ja] Remove",
    "accept": "[ja] Accept",
    "reject": "[ja] Reject",
    "cancel": "[ja] Cancel",
    "noFriends": "[ja] No friends yet",
    "noFriendsDesc": "[ja] Search for players and send friend requests",
    "lastGame": "[ja] Last game: {{time}}",
    "friendsSince": "[ja] Friends since {{date}}",
    "incomingRequests": "[ja] Incoming Requests",
    "outgoingRequests": "[ja] Outgoing Requests",
    "noIncoming": "[ja] No incoming requests",
    "noOutgoing": "[ja] No outgoing requests",
    "sentAt": "[ja] Sent {{time}}",
    "searchPlaceholder": "[ja] Search by name...",
    "noResults": "[ja] No players found",
    "noResultsDesc": "[ja] Try searching with a different name",
    "requestSent": "[ja] Friend request sent!",
    "requestAccepted": "[ja] Friend request accepted!",
    "requestRejected": "[ja] Friend request rejected",
    "requestCancelled": "[ja] Friend request cancelled",
    "friendRemoved": "[ja] Friend removed",
    "searchFailed": "[ja] Failed to search users",
    "requestFailed": "[ja] Failed to send request",
    "acceptFailed": "[ja] Failed to accept request",
    "rejectFailed": "[ja] Failed to reject request",
    "cancelFailed": "[ja] Failed to cancel request",
    "removeFailed": "[ja] Failed to remove friend",
    "friendsCount": "[ja] {{count}} friends",
    "gamesCount": "[ja] {{count}} games",
    "alreadyFriends": "[ja] Friends"
  },
  "stats": {
    "statistics": "[ja] Statistics",
    "matchHistory": "[ja] Match History",
    "headToHead": "[ja] Head to Head",
    "gamesPlayed": "[ja] Games Played",
    "wins": "[ja] Wins",
    "losses": "[ja] Losses",
    "draws": "[ja] Draws",
    "winRate": "[ja] Win Rate",
    "rating": "[ja] Rating",
    "peakRating": "[ja] Peak Rating",
    "peak": "[ja] Peak",
    "winStreak": "[ja] Win Streak",
    "currentStreak": "[ja] Current Streak",
    "bestStreak": "[ja] Best Streak",
    "performance": "[ja] Performance",
    "achievements": "[ja] Achievements",
    "currentRating": "[ja] Current Rating",
    "totalGames": "[ja] Total Games",
    "noGames": "[ja] No games played yet",
    "moves": "[ja] moves",
    "won": "[ja] Won",
    "lost": "[ja] Lost",
    "draw": "[ja] Draw",
    "overall": "[ja] Overall Record",
    "yourWins": "[ja] Your Wins",
    "theirWins": "[ja] Their Wins",
    "totalGamesPlayed": "[ja] Total: {{count}} games",
    "recentGames": "[ja] Recent Games"
  },
  "support": {
    "title": "サポート",
    "subtitle": "何かお手伝いできますか？",
    "tabs": {
      "docs": "[ja] Documentation",
      "faq": "[ja] FAQ",
      "contact": "[ja] Contact",
      "tickets": "[ja] My Tickets"
    },
    "categories": {
      "title": "[ja] Browse Documentation",
      "loading": "[ja] Loading documentation...",
      "loadError": "[ja] Failed to load categories",
      "articleCount": "[ja] {{count}} articles",
      "gettingStarted": "[ja] Getting Started",
      "features": "[ja] Features",
      "troubleshooting": "[ja] Troubleshooting",
      "account": "[ja] Account"
    },
    "docs": {
      "loading": "[ja] Loading document...",
      "loadError": "[ja] Failed to load document",
      "backToList": "[ja] Back to documentation"
    },
    "search": {
      "placeholder": "[ja] Search documentation...",
      "noResults": "[ja] No results found"
    },
    "faq": {
      "title": "[ja] Frequently Asked Questions",
      "loading": "[ja] Loading FAQ...",
      "loadError": "[ja] Failed to load FAQ",
      "empty": "[ja] No FAQ items in this category",
      "categories": {
        "all": "[ja] All Topics",
        "general": "[ja] General",
        "billing": "[ja] Billing",
        "technical": "[ja] Technical",
        "features": "[ja] Features"
      }
    },
    "contact": {
      "voiceTitle": "[ja] Voice Support",
      "voiceDescription": "[ja] Click the avatar button or say \"Jarvis\" to start a voice conversation with our AI assistant.",
      "ticketTitle": "[ja] Create Support Ticket",
      "ticketDescription": "[ja] Need human assistance? Create a support ticket and our team will respond within 24 hours.",
      "createTicket": "[ja] Create Ticket",
      "emailTitle": "[ja] Email Support",
      "emailDescription": "[ja] Prefer email? Reach us at support@bayit.tv for any questions or concerns."
    },
    "ticket": {
      "title": "[ja] Create Support Ticket",
      "subject": "[ja] Subject",
      "subjectPlaceholder": "[ja] Brief description of your issue",
      "message": "[ja] Message",
      "messagePlaceholder": "[ja] Describe your issue in detail...",
      "categoryLabel": "[ja] Category",
      "priorityLabel": "[ja] Priority",
      "submit": "[ja] Submit Ticket",
      "category": {
        "billing": "[ja] Billing",
        "technical": "[ja] Technical",
        "feature": "[ja] Feature Request",
        "general": "[ja] General"
      },
      "priority": {
        "low": "[ja] Low",
        "medium": "[ja] Medium",
        "high": "[ja] High",
        "urgent": "[ja] Urgent"
      },
      "status": {
        "open": "[ja] Open",
        "in_progress": "[ja] In Progress",
        "resolved": "[ja] Resolved",
        "closed": "[ja] Closed"
      },
      "created": "[ja] Created",
      "error": {
        "required": "[ja] Please fill in all required fields",
        "submit": "[ja] Failed to create ticket. Please try again."
      }
    },
    "tickets": {
      "title": "[ja] My Support Tickets",
      "loading": "[ja] Loading tickets...",
      "loadError": "[ja] Failed to load tickets",
      "empty": "[ja] No support tickets yet",
      "emptyFilter": "[ja] No tickets with this status",
      "create": "[ja] New Ticket",
      "createFirst": "[ja] Create Your First Ticket",
      "filter": {
        "all": "[ja] All",
        "open": "[ja] Open",
        "inProgress": "[ja] In Progress",
        "resolved": "[ja] Resolved"
      }
    },
    "voice": {
      "title": "[ja] Voice Assistant",
      "listening": "[ja] I'm listening...",
      "thinking": "[ja] Let me think about that...",
      "speaking": "[ja] Speaking...",
      "error": "[ja] Sorry, I didn't catch that. Try again?",
      "ready": "[ja] What would you like to know?",
      "listeningNow": "[ja] Listening...",
      "wakeWordHint": "[ja] Say \"Jarvis\" to speak"
    },
    "wizard": {
      "role": "[ja] Your Guide"
    }
  },
  "jerusalem": {
    "title": "[ja] Jerusalem Connection",
    "subtitle": "[ja] Stay connected to the heart of Israel",
    "noContent": "[ja] No Jerusalem content available",
    "sources": "[ja] Sources",
    "kotelLive": "[ja] Western Wall Live",
    "categories": {
      "kotel": "[ja] Western Wall",
      "idf-ceremony": "[ja] IDF Ceremonies",
      "diaspora-connection": "[ja] Diaspora Connection",
      "holy-sites": "[ja] Holy Sites",
      "jerusalem-events": "[ja] Jerusalem Events",
      "general": "[ja] Jerusalem"
    }
  },
  "telAviv": {
    "title": "[ja] Tel Aviv Connection",
    "subtitle": "[ja] The city that never stops",
    "noContent": "[ja] No Tel Aviv content available",
    "sources": "[ja] Sources",
    "beachLive": "[ja] Beach Webcam",
    "categories": {
      "beaches": "[ja] Beaches",
      "nightlife": "[ja] Nightlife",
      "culture": "[ja] Culture & Art",
      "music": "[ja] Music Scene",
      "food": "[ja] Food & Dining",
      "tech": "[ja] Tech & Startups",
      "events": "[ja] Events",
      "general": "[ja] Tel Aviv"
    }
  },
  "voiceOnboarding": {
    "welcome": {
      "title": "[ja] Welcome to Voice Control",
      "description": "[ja] Control Bayit+ with your voice for a hands-free experience."
    },
    "features": {
      "voiceCommands": "音声コマンド",
      "voiceCommandsDesc": "自然な言葉でナビゲート、検索、再生をコントロール",
      "tts": "テキスト読み上げ",
      "ttsDesc": "応答とコンテンツの説明を音声で聞く",
      "wakeWord": "ウェイクワード",
      "wakeWordDesc": "'Bayit'と言っていつでも音声コントロールを起動"
    },
    "getStarted": "始める",
    "permissions": {
      "title": "マイクへのアクセス",
      "description": "音声コントロールにはコマンドを聞くためのマイクアクセスが必要です",
      "privacy": "音声データは安全に処理され、保存されることはありません"
    },
    "permissionsGranted": "マイクアクセスが許可されました",
    "permissionRequired": {
      "title": "許可が必要です",
      "message": "音声コントロールを使用するには、デバイス設定でマイクアクセスを有効にしてください"
    },
    "grantPermissions": "許可を与える",
    "testWakeWord": {
      "title": "ウェイクワードをテスト",
      "description": "'Bayit'と言って音声起動をテスト",
      "success": "素晴らしい！音声起動が機能しています"
    },
    "startTest": "テスト開始",
    "complete": {
      "title": "準備完了！",
      "description": "音声コントロールが有効になりました。これらのコマンドを試してください：",
      "tryCommands": "これらのコマンドを試してください",
      "examples": {
        "search": "\"Faudaを検索\"",
        "play": "\"ニュースを再生\"",
        "navigate": "\"ライブTVに移動\"",
        "control": "\"一時停止\" または \"音量を上げて\""
      },
      "startUsing": "音声コントロールを使い始める"
    },
    "skip": "今はスキップ",
    "buttons": {
      "back": "[ja] Back"
    },
    "completion": {
      "message": "[ja] Voice features are ready to use.",
      "title": "[ja] Voice Setup Complete"
    },
    "title": "[ja] Voice Setup",
    "training": {
      "message": "[ja] Read the phrases aloud to train voice recognition.",
      "title": "[ja] Voice Training"
    }
  },
  "taxonomy": {
    "sections": {
      "movies": "[ja] Movies",
      "series": "[ja] Series",
      "kids": "[ja] Kids",
      "youngsters": "[ja] Youngsters",
      "music": "[ja] Music",
      "documentaries": "[ja] Documentaries",
      "podcasts": "[ja] Podcasts",
      "live": "[ja] Live TV"
    },
    "subcategories": {
      "learning-hebrew": "[ja] Learning Hebrew",
      "young-science": "[ja] Young Science",
      "math-fun": "[ja] Fun Math",
      "nature-animals": "[ja] Nature & Animals",
      "interactive": "[ja] Interactive",
      "hebrew-songs": "[ja] Hebrew Songs",
      "nursery-rhymes": "[ja] Nursery Rhymes",
      "kids-movies": "[ja] Kids Movies",
      "kids-series": "[ja] Kids Series",
      "jewish-holidays": "[ja] Jewish Holidays",
      "torah-stories": "[ja] Torah Stories",
      "bedtime-stories": "[ja] Bedtime Stories",
      "tiktok-trends": "[ja] TikTok Trends",
      "viral-videos": "[ja] Viral Videos",
      "memes": "[ja] Memes",
      "israel-news": "[ja] Israel News",
      "world-news": "[ja] World News",
      "science-news": "[ja] Science News",
      "sports-news": "[ja] Sports News",
      "music-culture": "[ja] Music Culture",
      "film-culture": "[ja] Film Culture",
      "art-culture": "[ja] Art Culture",
      "food-culture": "[ja] Food Culture",
      "study-help": "[ja] Study Help",
      "career-prep": "[ja] Career Prep",
      "life-skills": "[ja] Life Skills",
      "teen-movies": "[ja] Teen Movies",
      "teen-series": "[ja] Teen Series",
      "gaming": "[ja] Gaming",
      "coding": "[ja] Coding",
      "gadgets": "[ja] Gadgets",
      "bar-bat-mitzvah": "[ja] Bar/Bat Mitzvah",
      "teen-torah": "[ja] Teen Torah",
      "jewish-history": "[ja] Jewish History",
      "learning-hebrew.description": "子供向けヘブライ語の読み書きと語彙学習",
      "young-science.description": "子供向けの実験と科学的説明",
      "math-fun.description": "楽しく遊びながら数字と算数を学ぶ",
      "nature-animals.description": "好奇心旺盛な子供のための動物と自然の世界",
      "interactive.description": "子供向けのインタラクティブで参加型のコンテンツ",
      "hebrew-songs.description": "クラシックと新しいイスラエルの子供の歌",
      "nursery-rhymes.description": "幼児と赤ちゃんのための歌とメロディー",
      "kids-movies.description": "子供向けの長編映画",
      "kids-series.description": "子供向けアニメシリーズとテレビ番組",
      "jewish-holidays.description": "子供向けのユダヤ教の祝日と伝統に関するコンテンツ",
      "torah-stories.description": "トーラーとユダヤの伝統からの物語",
      "bedtime-stories.description": "就寝時のリラックスできるお話",
      "tiktok-trends.description": "TikTokで人気のトレンドとチャレンジ",
      "viral-videos.description": "SNSで人気のバイラル動画",
      "memes.description": "面白いミームとインターネット文化",
      "israel-news.description": "10代向けのイスラエルニュース",
      "world-news.description": "若者向けの国際ニュース",
      "science-news.description": "科学的発見と技術革新",
      "sports-news.description": "スポーツの最新情報と試合結果",
      "music-culture.description": "音楽シーン、アーティスト、フェスティバル",
      "film-culture.description": "映画、ドラマ、レビュー",
      "art-culture.description": "アート、ギャラリー、クリエイティビティ",
      "food-culture.description": "料理、レシピ、食文化",
      "study-help.description": "試験対策、要約、テスト準備のサポート",
      "career-prep.description": "大学とキャリアの準備",
      "life-skills.description": "ライフスキル、お金の管理、自立",
      "teen-movies.description": "10代におすすめの映画",
      "teen-series.description": "10代に人気のシリーズ",
      "gaming.description": "ビデオゲーム、eスポーツ、ゲーミング",
      "coding.description": "プログラミング、コーディング、ソフトウェア開発",
      "gadgets.description": "ガジェット、テクノロジー、レビュー",
      "bar-bat-mitzvah.description": "バル/バットミツバの準備とお祝い",
      "teen-torah.description": "10代向けトーラーの授業と週間パラシャ",
      "jewish-history.description": "ユダヤ民族の歴史"
    }
  },
  "passkey": {
    "manager": {
      "title": "[ja] Passkeys",
      "subtitle": "[ja] Manage your passkeys for secure content access"
    },
    "unsupported": "[ja] Passkeys are not supported on this device",
    "fetchError": "[ja] Failed to load passkeys",
    "registerError": "[ja] Failed to register passkey",
    "deleteError": "[ja] Failed to delete passkey",
    "cancelled": "[ja] Passkey operation was cancelled",
    "noPasskeys": "[ja] No passkeys registered yet. Add one to unlock private content.",
    "unknownDevice": "[ja] Unknown Device",
    "created": "[ja] Created",
    "lastUsed": "[ja] Last used",
    "never": "[ja] Never",
    "addPasskey": "[ja] Add Passkey",
    "deleteConfirmTitle": "[ja] Delete Passkey?",
    "deleteConfirmText": "[ja] This passkey will no longer be able to unlock content. You can always add it again later.",
    "unlock": "[ja] Unlock",
    "unlockContent": "[ja] Unlock Private Content",
    "unlockDescription": "[ja] Use your passkey to access private movies and series",
    "auth": {
      "title": "[ja] Unlock Content",
      "description": "[ja] Use your fingerprint, face, or device PIN to unlock private movies and series.",
      "unlock": "[ja] Unlock with Passkey",
      "authenticating": "[ja] Authenticating...",
      "success": "[ja] Content Unlocked!",
      "cancelled": "[ja] Authentication was cancelled",
      "error": "[ja] Authentication failed. Please try again."
    },
    "qr": {
      "useQR": "[ja] Use Phone to Unlock",
      "scanWithPhone": "[ja] Scan with your phone",
      "instruction": "[ja] Open the camera on your phone and scan the QR code to authenticate",
      "error": "[ja] Failed to generate QR code",
      "expired": "[ja] QR code expired. Please try again."
    }
  },
  "olorin": {
    "errors": {
      "session_not_found": "[ja] Session not found",
      "session_different_partner": "[ja] Session belongs to different partner",
      "session_invalid_status": "[ja] Session is {status}, cannot add transcript",
      "max_sessions_reached": "[ja] Maximum concurrent sessions ({limit}) reached",
      "invalid_api_key": "[ja] Invalid API key",
      "missing_api_key": "[ja] Missing {header} header",
      "capability_disabled": "[ja] Capability '{capability}' is currently disabled",
      "capability_not_enabled": "[ja] Capability '{capability}' not enabled for this partner",
      "source_language_not_supported": "[ja] Source language '{language}' not supported. Supported: {supported}",
      "target_language_not_supported": "[ja] Target language '{language}' not supported. Supported: {supported}",
      "partner_not_found": "[ja] Partner not found",
      "partner_registration_failed": "[ja] Failed to register partner",
      "no_updates_provided": "[ja] No updates provided",
      "webhook_config_failed": "[ja] Failed to configure webhook",
      "webhook_url_not_configured": "[ja] Webhook URL not configured",
      "webhook_secret_not_configured": "[ja] Webhook secret not configured",
      "search_failed": "[ja] Search failed",
      "indexing_failed": "[ja] Indexing failed",
      "detection_failed": "[ja] Detection failed",
      "explanation_failed": "[ja] Failed to get explanation",
      "reference_not_found": "[ja] Reference '{reference_id}' not found",
      "enrichment_failed": "[ja] Enrichment failed",
      "get_references_failed": "[ja] Failed to get references",
      "create_session_failed": "[ja] Failed to create session",
      "add_transcript_failed": "[ja] Failed to add transcript",
      "generate_recap_failed": "[ja] Failed to generate recap"
    }
  },
  "portal": {
    "nav": {
      "home": "ホーム",
      "features": "機能",
      "solutions": "ソリューション",
      "pricing": "料金",
      "demo": "ライブデモ",
      "contact": "お問い合わせ",
      "getStarted": "始める"
    },
    "hero": {
      "ctaExplore": "機能を見る",
      "ctaDemo": "デモを依頼"
    },
    "cta": {
      "title": "始める準備はできましたか？",
      "subtitle": "ビジネスの変革をお手伝いする方法について話し合いましょう",
      "button": "お問い合わせ"
    },
    "contactPage": {
      "title": "お問い合わせ",
      "subtitle": "当社のソリューションに興味がありますか？お話ししましょう",
      "formTitle": "メッセージを送信",
      "infoTitle": "連絡先情報",
      "form": {
        "name": "フルネーム",
        "email": "メールアドレス",
        "company": "会社名",
        "phone": "電話番号",
        "message": "メッセージ",
        "messagePlaceholder": "ニーズについて教えてください..."
      },
      "submit": "メッセージを送信",
      "sending": "送信中...",
      "success": "メッセージが正常に送信されました！すぐにご連絡いたします。",
      "error": "メッセージの送信に失敗しました。もう一度お試しください。",
      "scheduleTitle": "通話をスケジュールしますか？",
      "scheduleSubtitle": "チームとパーソナライズされたデモを予約",
      "scheduleCta": "デモ通話をスケジュール"
    },
    "pricingPage": {
      "title": "手頃な",
      "titleHighlight": "料金プラン",
      "subtitle": "ニーズに合ったプランを選択",
      "comparisonTitle": "機能比較",
      "faqTitle": "よくある質問",
      "faq": {
        "q1": "料金はどのように計算されますか？",
        "a1": "料金は、特定のニーズと使用状況に基づいています。カスタム見積もりについてはお問い合わせください。",
        "q2": "後でプランをアップグレードできますか？",
        "a2": "はい、いつでもアップグレードできます。データのスムーズな移行をお手伝いします。",
        "q3": "どのようなサポートが含まれていますか？",
        "a3": "すべてのプランにメールサポートが含まれています。プロフェッショナルプランとエンタープライズプランには、専任のアカウントマネージャーによる優先サポートが含まれています。"
      },
      "professional": {
        "name": "プロフェッショナル",
        "price": "見積もりはお問い合わせください",
        "priceNote": "カスタム料金",
        "description": "高度なニーズを持つ成長企業向け",
        "cta": "見積もりを取得"
      },
      "enterprise": {
        "name": "エンタープライズ",
        "price": "カスタム",
        "priceNote": "ボリュームベース",
        "description": "大規模組織とエンタープライズ展開向け",
        "cta": "営業に連絡"
      },
      "ctaTitle": "始める準備はできましたか？",
      "ctaSubtitle": "ニーズについて話し合い、最適なプランを見つけましょう",
      "ctaButton": "営業に連絡"
    },
    "featuresPage": {
      "title": "強力な",
      "titleHighlight": "機能",
      "subtitle": "成功に必要なすべて",
      "techSpecsTitle": "技術仕様",
      "workflowTitle": "仕組み",
      "workflow": {
        "s1": {
          "title": "インポート",
          "description": "コンテンツをアップロードして整理"
        },
        "s2": {
          "title": "構成",
          "description": "設定と環境設定を設定"
        },
        "s3": {
          "title": "展開",
          "description": "ソリューションでライブに"
        },
        "s4": {
          "title": "監視",
          "description": "パフォーマンスを追跡して最適化"
        }
      },
      "ctaTitle": "機能を探索する準備はできましたか？",
      "ctaSubtitle": "パーソナライズされたデモですべての機能を確認",
      "ctaButton": "デモをスケジュール"
    },
    "demoPage": {
      "title": "当社の",
      "titleHighlight": "プラットフォーム",
      "subtitle": "ソリューションの力を体験",
      "scheduleCta": "ライブデモをスケジュール",
      "stepsTitle": "仕組み",
      "steps": {
        "analyze": {
          "title": "分析",
          "description": "パフォーマンスを追跡して改善"
        }
      },
      "featuresTitle": "プラットフォームのハイライト",
      "platformsTitle": "利用可能",
      "ctaTitle": "カスタムデモの準備はできましたか？",
      "ctaSubtitle": "ニーズに合わせたパーソナライズされたデモをスケジュール",
      "ctaButton": "デモをスケジュール"
    },
    "workflow": {
      "sectionTitle": "インテリジェントワークフロー",
      "sectionSubtitle": "4ステップの合理化されたプロセス",
      "step1": {
        "title": "セットアップ",
        "description": "アカウントと設定を構成"
      },
      "step2": {
        "title": "カスタマイズ",
        "description": "ニーズに合わせて設定をカスタマイズ"
      },
      "step3": {
        "title": "展開",
        "description": "ソリューションを開始"
      },
      "step4": {
        "title": "監視",
        "description": "パフォーマンスを追跡して最適化"
      }
    }
  },
  "trivia": {
    "didYouKnow": "知っていますか？",
    "dismissHint": "トリビアを閉じる",
    "settings": {
      "displayLanguages": "表示言語",
      "languageHint": "各トリビアに表示する1〜3つの言語を選択",
      "language": "言語",
      "selectLanguage": "この言語を選択",
      "deselectLanguage": "この言語の選択を解除",
      "enableDescription": "[ja] Show trivia questions while watching content.",
      "enableTrivia": "[ja] Enable Trivia",
      "title": "[ja] Trivia Settings"
    },
    "aiTrivia": "AIトリビア",
    "tellMeMore": "もっと教えて",
    "more": "もっと",
    "follow_up": "フォローアップ"
  },
  "auth": {
    "loginRequired": "[ja] Login Required",
    "loginToWatch": "[ja] Please sign in to watch {{title}}",
    "login": "[ja] Login",
    "signUp": "[ja] Sign Up",
    "biometricEnrollEnable": "[ja] Enable",
    "biometricEnrollMessage": "[ja] Use Face ID or fingerprint for faster sign-in next time.",
    "biometricEnrollSkip": "[ja] Skip",
    "biometricEnrollTitle": "[ja] Enable Biometric Sign-In",
    "biometricSignIn": "[ja] Sign in with Biometrics",
    "signOut": "[ja] Sign Out",
    "register": {
      "createAccount": "アカウント作成",
      "email": "メールアドレス",
      "password": "パスワード",
      "confirmPassword": "パスワード確認",
      "register": "登録",
      "alreadyHaveAccount": "既にアカウントをお持ちですか？サインイン",
      "passwordStrength": {
        "weak": "弱い",
        "medium": "普通",
        "strong": "強い"
      }
    }
  },
  "recording": {
    "stop": "録音を停止",
    "start": "録音を開始"
  },
  "discover": {
    "title": "[ja] Discover",
    "subtitle": "19のAI搭載機能を探索する",
    "description": "Bayit+はAIを活用して視聴、聴取、学習体験を向上させます。お使いのプラットフォームで利用可能な機能をご覧ください。",
    "featureCount": "{{count}}の機能",
    "tryIt": "試してみる",
    "startWalkthrough": "ウォークスルーを開始",
    "availableOn": "対応プラットフォーム",
    "prerequisites": "前提条件",
    "setup": "設定する",
    "error": {
      "fetchFailed": "Discoverの機能を読み込めませんでした。もう一度お試しください。",
      "unknownFeature": "機能が見つかりません。",
      "featureDisabled": "この機能は現在無効になっています。"
    },
    "availability": {
      "ready": "利用可能",
      "setupNeeded": "設定が必要",
      "premiumRequired": "プレミアム必須",
      "notAvailable": "利用不可",
      "platformOnly": "他のプラットフォーム"
    },
    "platform": {
      "web": "Web",
      "ios": "iOS",
      "android": "Android",
      "tvos": "Apple TV"
    },
    "category": {
      "watching_movies": "映画を観る",
      "watching_live_tv": "ライブTVを観る",
      "learn_hebrew": "ヘブライ語を学ぶ",
      "search_discovery": "検索と発見",
      "chat_assistants": "チャットアシスタント"
    },
    "feature": {
      "pause_ask": {
        "name": "一時停止して質問",
        "tagline": "任意のシーンを一時停止してAIコンパニオンに質問する",
        "description": "視聴中にビデオを一時停止して、現在のシーンについて質問できます。AIキャラクターが文化的な背景を説明し、セリフを翻訳し、ストーリーについて解説します。"
      },
      "interactive_subtitles": {
        "name": "インタラクティブ字幕",
        "tagline": "字幕の任意の単語をタップして即座に翻訳と文脈を取得",
        "description": "字幕の任意の単語をクリックして翻訳を確認し、発音を聞き、使用例を取得できます。お気に入りの番組を観ながら語彙を増やしましょう。"
      },
      "vocabulary": {
        "name": "語彙ビルダー",
        "tagline": "観ている番組から新しい単語を学ぶ",
        "description": "字幕から新しいヘブライ語単語を自動的に収集します。フラッシュカードで復習し、進捗を追跡し、楽しめるコンテンツを通じて語彙を増やしましょう。"
      },
      "vod_moments": {
        "name": "VODモーメント",
        "tagline": "お気に入りのコンテンツからAIが厳選したハイライト",
        "description": "映画や番組からAIが生成したハイライトクリップと重要な瞬間を取得できます。印象的なシーンを共有し、最高のシーンを見直しましょう。"
      },
      "cultural_context": {
        "name": "文化的背景",
        "tagline": "すべてのシーンの背後にある文化的背景を理解する",
        "description": "視聴しているコンテンツに登場するイスラエルの慣習、祝日、ユーモア、社会規範をリアルタイムで説明する文化的注釈を受け取れます。"
      },
      "bilingual_bridge": {
        "name": "バイリンガルブリッジ",
        "tagline": "視聴しながらヘブライ語と日本語を並行して学ぶ",
        "description": "重要な語彙がハイライトされた二か国語字幕を表示します。ヘブライ語と母国語を切り替えて、自然に理解力を養いましょう。"
      },
      "ai_companion": {
        "name": "AIコンパニオン",
        "tagline": "イスラエルのコンテンツを案内するあなた専用のAIガイド",
        "description": "一緒に視聴するAIキャラクターが解説を提供し、質問に答え、イスラエルのメディアの微妙なニュアンスを理解するのを助けます。"
      },
      "live_dubbing": {
        "name": "ライブ吹き替え",
        "tagline": "イスラエルのライブTVチャンネルのリアルタイムAI吹き替え",
        "description": "お好みの言語でAI搭載のリアルタイム吹き替えを付けてイスラエルのライブTVを視聴できます。言語の壁なくニュース、トークショー、エンターテインメントを楽しめます。"
      },
      "live_subtitles": {
        "name": "ライブ字幕",
        "tagline": "ライブ放送向けのリアルタイムAI字幕",
        "description": "イスラエルのライブTVを視聴しながらリアルタイムでAI生成の字幕を取得できます。ライブコンテンツの即時翻訳にお好みの言語を選択してください。"
      },
      "live_trivia": {
        "name": "ライブトリビア",
        "tagline": "放映中の内容に基づいてトリビアゲームをプレイ",
        "description": "AIがライブ放送からトピックを検出してリアルタイムでトリビア問題を生成します。友達と競いながらTV視聴でイスラエル文化を学びましょう。"
      },
      "catch_up": {
        "name": "キャッチアップ",
        "tagline": "ライブTVで見逃した内容のAI要約",
        "description": "ライブ放送の一部を見逃しましたか？何が起きたかを教えてくれるAI生成の要約を取得し、重要な瞬間がハイライトされているのですぐに確認できます。"
      },
      "scene_search": {
        "name": "シーン検索",
        "tagline": "すべてのコンテンツから特定のシーンを検索",
        "description": "覚えているシーンを説明すると、AIがすべての利用可能なコンテンツから見つけ出します。セリフ、映像要素、またはあらすじで検索できます。"
      },
      "phonetic_mirror": {
        "name": "フォネティックミラー",
        "tagline": "AIフィードバックでヘブライ語の発音を練習",
        "description": "ヘブライ語を話しながら自分を録音し、発音について即座のAIフィードバックを受け取りましょう。ネイティブスピーカーと比較し、時間の経過とともに改善を追跡します。"
      },
      "talk_back": {
        "name": "トークバック",
        "tagline": "AIキャラクターとヘブライ語で音声会話をする",
        "description": "AIキャラクターと話してヘブライ語の会話を練習しましょう。自然な対話の中で文法、語彙、発音についてリアルタイムのフィードバックを受け取れます。"
      },
      "interactive_mission": {
        "name": "インタラクティブミッション",
        "tagline": "AIガイダンスで楽しいヘブライ語学習チャレンジ",
        "description": "コンテンツ視聴とヘブライ語学習の演習を組み合わせたAIガイドのミッションを完了しましょう。報酬を獲得し、言語学習の旅を追跡できます。"
      },
      "glossary": {
        "name": "パーソナルグロッサリー",
        "tagline": "コンテンツから構築したあなた専用のヘブライ語辞書",
        "description": "出会って保存したすべてのヘブライ語単語が、カテゴリー、頻度、習熟度別に整理されています。いつでも復習して練習できます。"
      },
      "llm_search": {
        "name": "AI検索",
        "tagline": "自然言語クエリでコンテンツを検索",
        "description": "自然言語を使用してBayit+ライブラリ全体を検索できます。「家族についての面白いイスラエルのコメディ」や「テルアビブについてのドキュメンタリー」を尋ね、AIが厳選した結果を取得しましょう。"
      },
      "proactive_voice": {
        "name": "プロアクティブボイス",
        "tagline": "あなたのニーズを先読みする音声優先AIアシスタント",
        "description": "視聴中の内容に基づいて、関連するコンテンツの提案、翻訳、学習機会を積極的に提供するAIアシスタントです。"
      },
      "chatbot": {
        "name": "Bayitチャット",
        "tagline": "イスラエルのコンテンツに関するあらゆることをAIとチャット",
        "description": "イスラエル文化について質問し、コンテンツの推薦を受け、ヘブライ語を練習し、または視聴した内容について話し合いましょう。AIコンパニオンはいつでも利用できます。"
      }
    },
    "prereq": {
      "avatar": "AIキャラクターを作成する",
      "subscription": "プレミアムサブスクリプションが必要",
      "microphone": "マイクへのアクセスが必要",
      "contentType": "コンテンツの好みを選択する",
      "preference": "言語の好みを設定する",
      "voiceClone": "ボイスクローンを設定する"
    },
    "walkthrough": {
      "tryItNow": "[ja] Try it now",
      "watchDemo": "[ja] Watch demo",
      "skip": "[ja] Skip",
      "next": "[ja] Next",
      "done": "[ja] Done",
      "complete": "[ja] Walkthrough complete",
      "stepCounter": "[ja] {{current}} of {{total}}",
      "pause_ask": {
        "step1": "[ja] Navigate to a movie with interactive moments",
        "step2": "[ja] Pause the movie during a scene",
        "step3": "[ja] Tap the Ask a Character button",
        "step4": "[ja] Watch the character respond to you"
      },
      "interactive_subtitles": {
        "step1": "[ja] Start playing a movie with subtitles",
        "step2": "[ja] Tap the Interactive button in the control bar",
        "step3": "[ja] Select your subtitle language",
        "step4": "[ja] Tap any word in the subtitles to learn more"
      },
      "vocabulary": {
        "step1": "[ja] Open a movie with interactive subtitles enabled",
        "step2": "[ja] Tap a word you want to learn",
        "step3": "[ja] Tap Save to Vocabulary",
        "step4": "[ja] Review your saved words in the Vocabulary section"
      },
      "vod_moments": {
        "step1": "[ja] Start watching a movie with interactive moments",
        "step2": "[ja] Wait for an interactive prompt to appear",
        "step3": "[ja] See the AI-generated interaction"
      },
      "cultural_context": {
        "step1": "[ja] Play a movie with Hebrew dialogue",
        "step2": "[ja] Tap on a subtitle with cultural significance",
        "step3": "[ja] Read the AI-generated cultural explanation"
      },
      "bilingual_bridge": {
        "step1": "[ja] Open a movie with bilingual support",
        "step2": "[ja] Select the bilingual subtitle mode",
        "step3": "[ja] Tap a highlighted phrase to see the translation",
        "step4": "[ja] Watch both languages side by side"
      },
      "ai_companion": {
        "step1": "[ja] Start watching any movie",
        "step2": "[ja] Tap the AI Companion button",
        "step3": "[ja] Type a question about the movie",
        "step4": "[ja] Read the contextual AI response"
      },
      "live_dubbing": {
        "step1": "[ja] Navigate to a live TV channel",
        "step2": "[ja] Tap the dubbing button in the control bar",
        "step3": "[ja] Select your preferred language",
        "step4": "[ja] Listen to the real-time AI dubbing"
      },
      "live_subtitles": {
        "step1": "[ja] Navigate to a live TV channel",
        "step2": "[ja] Tap the subtitles button",
        "step3": "[ja] Select your subtitle language",
        "step4": "[ja] Watch the real-time subtitles appear"
      },
      "live_trivia": {
        "step1": "[ja] Navigate to a live TV channel",
        "step2": "[ja] Tap the trivia button",
        "step3": "[ja] Answer the AI-generated questions"
      },
      "catch_up": {
        "step1": "[ja] Navigate to a live broadcast",
        "step2": "[ja] Select the catch-up option",
        "step3": "[ja] Tap to generate an AI summary",
        "step4": "[ja] Read the summary of what you missed"
      },
      "scene_search": {
        "step1": "[ja] Navigate to a recorded broadcast",
        "step2": "[ja] Type what you are looking for",
        "step3": "[ja] Tap on the matching scene",
        "step4": "[ja] Watch the scene from that point"
      },
      "phonetic_mirror": {
        "step1": "[ja] Open the Phonetic Mirror in Zeh Ani",
        "step2": "[ja] Read the Hebrew phrase shown",
        "step3": "[ja] Speak the phrase into your microphone",
        "step4": "[ja] Review the AI pronunciation feedback"
      },
      "talk_back": {
        "step1": "[ja] Open Talk Back in Zeh Ani",
        "step2": "[ja] Listen to your avatar speak Hebrew",
        "step3": "[ja] Respond in Hebrew using your microphone",
        "step4": "[ja] Review the AI feedback on your response"
      },
      "interactive_mission": {
        "step1": "[ja] Open Interactive Missions",
        "step2": "[ja] Select a mission level",
        "step3": "[ja] Follow the AI-guided exercises",
        "step4": "[ja] Complete the mission and earn rewards"
      },
      "glossary": {
        "step1": "[ja] Open the Hebrew Glossary",
        "step2": "[ja] Search for a Hebrew word",
        "step3": "[ja] Listen to the pronunciation"
      },
      "llm_search": {
        "step1": "[ja] Open the Search tab",
        "step2": "[ja] Type a natural language query",
        "step3": "[ja] Browse the AI-curated results"
      },
      "proactive_voice": {
        "step1": "[ja] Open the Voice Suggestions feature",
        "step2": "[ja] Tap and hold to speak",
        "step3": "[ja] Hear the personalized recommendations"
      },
      "chatbot": {
        "step1": "[ja] Open the AI Assistant",
        "step2": "[ja] Type your question or request",
        "step3": "[ja] Read the AI response"
      }
    }
  },
  "byoc": {
    "home": {
      "title": "[ja] Bring Your Own Content",
      "subtitle": "[ja] Connect your IPTV, Plex, or YouTube sources and enjoy Bayit+ AI features on your own content",
      "connectButton": "[ja] Connect Sources",
      "aiFeatures": {
        "dubbing": "[ja] AI Dubbing available",
        "subtitles": "[ja] Live Subtitles available"
      }
    },
    "pageSubtitle": "あなた自身のコンテンツを持ち込む - IPTVとストリーミングソースを追加",
    "addSource": "ソースを追加",
    "sync": "同期",
    "remove": "削除",
    "channelCount": "{{count}} チャンネル",
    "empty": {
      "title": "ソースが追加されていません",
      "subtitle": "Bayit+とともに自分のコンテンツを視聴するために、IPTV、Xtream、またはストリーミングソースを追加してください"
    },
    "source": {
      "iptv": "IPTVソース",
      "xtream": "Xtream Codes"
    },
    "sourceType": {
      "iptv": "IPTV / M3U",
      "xtream": "Xtream Codes"
    },
    "addIptv": {
      "title": "IPTVソースを追加",
      "subtitle": "M3UまたはM3U8プレイリストファイルのURLを入力してください",
      "urlPlaceholder": "https://example.com/playlist.m3u",
      "validate": "検証",
      "add": "ソースを追加"
    },
    "addXtream": {
      "title": "Xtream Codesに接続",
      "subtitle": "Xtream Codesサーバーの認証情報を入力してください",
      "serverUrl": "サーバーURL",
      "username": "ユーザー名",
      "password": "パスワード",
      "connect": "接続"
    },
    "preview": {
      "title": "プレビュー",
      "channelCount": "{{count}} チャンネルが見つかりました"
    },
    "providers": {
      "title": "人気のプロバイダー"
    },
    "wizard": {
      "step1": "ソースを追加",
      "step2": "処理中",
      "step3": "確認",
      "selectSource": "ソースタイプを選択"
    },
    "normalization": {
      "title": "コンテンツを処理しています",
      "total": "合計 {{count}} チャンネル",
      "matched": "{{count}} 件一致",
      "stage": {
        "parsing": "プレイリストを解析中...",
        "matching": "チャンネルをマッチング中...",
        "enriching": "メタデータを充実させています...",
        "finalizing": "最終処理中..."
      }
    },
    "review": {
      "title": "インポートしたコンテンツを確認",
      "subtitle": "{{matched}} 件一致、{{unmatched}} チャンネル不一致",
      "matchedChannels": "一致したチャンネル",
      "unmatchedChannels": "一致しなかったチャンネル",
      "apply": "適用してインポート"
    },
    "error": {
      "urlRequired": "URLを入力してください",
      "noChannels": "このプレイリストにはチャンネルが見つかりませんでした",
      "invalidUrl": "このURLからプレイリストを読み込めませんでした",
      "allFieldsRequired": "すべてのフィールドが必要です",
      "enrichFailed": "ソースの分析に失敗しました",
      "syncFailed": "ソースの同期に失敗しました",
      "normalizationFailed": "コンテンツの処理に失敗しました",
      "normalizationPollFailed": "処理中に接続が失われました"
    },
    "plex": {
      "connectPlex": "Plexに接続",
      "enterCodeAt": "このコードを入力してください",
      "waitingForAuth": "認証を待っています...",
      "selectServer": "Plexサーバーを選択",
      "connecting": "{{serverName}}に接続中...",
      "connected": "接続済み",
      "label": "Plex"
    },
    "settings": {
      "title": "コンテンツソース",
      "refresh": "更新",
      "noSources": "コンテンツソースが接続されていません",
      "noSourcesSubtitle": "Plex、YouTube、IPTVまたはXtreamプロバイダーを接続してください",
      "removeSource": "ソースを削除",
      "plexSubtitle": "Plexメディアサーバーからストリーミング",
      "youtubeSubtitle": "YouTubeライブラリにアクセス",
      "iptvXtreamLabel": "IPTV / Xtream",
      "iptvXtreamSubtitle": "M3Uプレイリストまたは Xtreamコードを追加",
      "youtube": "YouTube",
      "xtreamCodes": "Xtream Codes",
      "iptv": "IPTV"
    }
  },
  "onboarding": {
    "welcome": {
      "title": "Bayit+へようこそ",
      "subtitle": "イスラエルのコンテンツ、文化、語学学習へのAI搭載ゲートウェイ",
      "getStarted": "始める"
    },
    "highlight": {
      "dubbing": "ライブAI吹き替え",
      "subtitles": "インタラクティブ字幕",
      "ai": "AIコンパニオン",
      "learning": "ヘブライ語学習"
    },
    "voice": {
      "title": "音声設定",
      "subtitle": "音声コマンド、ヘブライ語発音練習、ハンズフリーナビゲーションのためにマイクを有効にしてください",
      "enable": "マイクを有効にする",
      "granted": "マイクが正常に有効になりました"
    },
    "tour": {
      "done": "完了"
    },
    "demo": {
      "dubbing": {
        "title": "ライブAI吹き替え",
        "description": "お好みの言語でリアルタイムAI吹き替え付きでイスラエルのテレビを視聴",
        "hebrew": "ヘブライ語",
        "english": "英語"
      },
      "subtitles": {
        "title": "インタラクティブ字幕",
        "description": "字幕の任意の単語をタップして即座に翻訳と発音を確認",
        "sample": "家族がShabbatの夕食に集まった",
        "word": "シャバット",
        "translation": "シャバット - 週間の安息日"
      },
      "interaction": {
        "title": "AIキャラクターとのインタラクション",
        "description": "任意のシーンを一時停止して、文化的背景についてAIコンパニオンに質問",
        "userMsg": "何の祝日を祝っているのですか？",
        "aiMsg": "彼らはSukkot（仮庵の祭り）を祝っています。見えている仮の小屋はsukkahと呼ばれています。"
      },
      "trivia": {
        "title": "ライブトリビア",
        "description": "AIが放送中の内容からトリビア問題を生成します。競い合って学ぼう！",
        "question": "イスラエルの公用語は何ですか？",
        "optionA": "アラビア語",
        "optionB": "ヘブライ語",
        "optionC": "英語"
      },
      "catchup": {
        "title": "スマートキャッチアップ",
        "description": "ライブ放送の一部を見逃しましたか？AIが見逃した部分を要約します",
        "missed": "見逃した",
        "summary": "AI要約",
        "live": "ライブ配信中"
      },
      "byoc": {
        "title": "独自コンテンツを持ち込む",
        "description": "IPTVソースをインポートしてBayit+コンテンツと一緒に視聴",
        "step1": "ソースを追加",
        "step2": "AI強化",
        "step3": "視聴する"
      },
      "zehAni": {
        "title": "AIキャラクターを作成",
        "description": "あなたと一緒に学ぶパーソナライズされたAIアバターを生成",
        "generated": "AIアバター"
      }
    }
  },
  "dm": {
    "title": "メッセージ",
    "conversations": "会話",
    "conversation": "会話",
    "empty": {
      "title": "まだメッセージはありません",
      "subtitle": "友達との会話を始めましょう"
    },
    "input": {
      "placeholder": "メッセージを入力...",
      "send": "送信"
    },
    "translate": "翻訳",
    "react": "リアクション",
    "read": "既読",
    "sent": "送信済み",
    "loadMore": "以前のメッセージを読み込む",
    "startConversation": "メッセージを送って会話を始めましょう",
    "reaction": {
      "like": "いいね",
      "love": "大好き",
      "laugh": "笑",
      "surprise": "驚き",
      "sad": "悲しい"
    },
    "error": {
      "fetchFailed": "メッセージの読み込みに失敗しました",
      "sendFailed": "メッセージの送信に失敗しました"
    }
  },
  "household": {
    "empty": {
      "title": "まだ世帯はありません",
      "subtitle": "家族を管理するために世帯を作成してください"
    },
    "create": {
      "namePlaceholder": "世帯名",
      "button": "世帯を作成"
    },
    "members": "メンバー",
    "role": {
      "owner": "オーナー",
      "guardian": "保護者",
      "child": "子供"
    },
    "invite": {
      "title": "メンバーを招待",
      "emailPlaceholder": "メールアドレス",
      "send": "招待を送信",
      "pending": "保留中の招待"
    },
    "removeMember": "削除",
    "error": {
      "fetchFailed": "世帯の読み込みに失敗しました",
      "createFailed": "世帯の作成に失敗しました",
      "updateFailed": "世帯の更新に失敗しました",
      "deleteFailed": "世帯の削除に失敗しました",
      "inviteFailed": "招待の送信に失敗しました",
      "removeFailed": "メンバーの削除に失敗しました"
    }
  },
  "aiChat": {
    "retryButton": "[ja] Retry",
    "sendButton": "[ja] Send",
    "title": "[ja] AI Chat",
    "voiceButton": "[ja] Voice"
  },
  "aiOnboarding": {
    "buttons": {
      "back": "[ja] Back"
    },
    "completion": {
      "message": "[ja] You're all set! Start exploring AI features.",
      "title": "[ja] Setup Complete"
    },
    "permissions": {
      "description": "[ja] Grant permissions to enable AI features like voice and camera.",
      "title": "[ja] Permissions"
    },
    "personalization": {
      "description": "[ja] Tell us your preferences to personalize your AI experience.",
      "title": "[ja] Personalization"
    },
    "title": "[ja] AI Setup",
    "welcome": {
      "description": "[ja] Bayit+ uses AI to enhance your viewing experience with dubbing, subtitles, and more.",
      "title": "[ja] Welcome to Bayit+ AI"
    }
  },
  "auth_device_authorized": "[ja] Device authorized",
  "auth_device_code_expired": "[ja] Code expired",
  "auth_device_get_new_code": "[ja] Get new code",
  "auth_device_manual_login": "[ja] Sign in manually",
  "auth_device_visit_uri": "[ja] Visit the URL shown on your TV",
  "avatar": {
    "tapToSpeak": "[ja] Tap to speak",
    "title": "[ja] Avatar"
  },
  "dubbing": {
    "mixer": {
      "dubbedAudio": "[ja] Dubbed Audio",
      "originalAudio": "[ja] Original Audio",
      "title": "[ja] Audio Mixer"
    },
    "settings_title": "[ja] Dubbing Settings",
    "target_language": "[ja] Target Language",
    "voiceSelector": {
      "selected": "[ja] Selected",
      "subtitle": "[ja] Choose a voice for dubbing",
      "title": "[ja] Voice Selection"
    }
  },
  "go_back": "[ja] Go Back",
  "miniPlayer": {
    "closePlayer": "[ja] Close Player",
    "skipBackward": "[ja] Skip Backward",
    "skipForward": "[ja] Skip Forward"
  },
  "retry": "[ja] Retry",
  "search_hint": "[ja] Search channels, movies, shows...",
  "search_no_results": "[ja] No results found",
  "search_prompt": "[ja] What are you looking for?",
  "subscription_required": "[ja] Subscription Required",
  "subscription_upsell_tv": "[ja] Upgrade to watch on TV",
  "talkback": {
    "title": "[ja] Talkback"
  },
  "voiceAssistant": {
    "fabLabel": "[ja] Voice Assistant",
    "modal": {
      "cancel": "[ja] Cancel",
      "setupMessage": "[ja] Set up voice recognition to use the voice assistant.",
      "setupRequired": "[ja] Setup Required",
      "startSetup": "[ja] Start Setup",
      "title": "[ja] Voice Assistant"
    }
  },
  "voiceCommand": {
    "executing": "[ja] Executing...",
    "listening": "[ja] Listening...",
    "noMatch": "[ja] No match found",
    "recognized": "[ja] Recognized"
  },
  "voiceDecision": {
    "cancel": "[ja] Cancel",
    "confirm": "[ja] Confirm",
    "matched": "[ja] Matched"
  },
  "voiceSearch": {
    "listening": "[ja] Listening...",
    "noResults": "[ja] No results found",
    "tapToSpeak": "[ja] Tap to speak",
    "title": "[ja] Voice Search"
  },
  "voiceSettings": {
    "language": "[ja] Language",
    "speechRate": "[ja] Speech Rate",
    "title": "[ja] Voice Settings",
    "ttsProvider": "[ja] TTS Provider",
    "voiceMode": "[ja] Voice Mode",
    "voiceSelection": "[ja] Voice Selection",
    "wakeWord": "[ja] Wake Word"
  },
  "voiceWizard": {
    "buttons": {
      "back": "[ja] Back"
    },
    "calibration": {
      "description": "[ja] Speak normally to calibrate the microphone.",
      "listening": "[ja] Listening...",
      "micButton": "[ja] Start Recording",
      "resultTitle": "[ja] Calibration Result",
      "stopButton": "[ja] Stop Recording",
      "tapToStart": "[ja] Tap to start calibration",
      "title": "[ja] Microphone Calibration"
    },
    "complete": {
      "message": "[ja] Voice wizard setup is complete. You can now use voice features.",
      "title": "[ja] Setup Complete"
    },
    "language": {
      "description": "[ja] Select your preferred language for voice commands.",
      "title": "[ja] Voice Language"
    },
    "permission": {
      "description": "[ja] Microphone access is needed for voice features.",
      "granted": "[ja] Permission Granted",
      "requestButton": "[ja] Grant Permission",
      "title": "[ja] Microphone Permission"
    },
    "title": "[ja] Voice Wizard"
  },
  "watch_now": "[ja] Watch Now",
  "culture": {
    "title": "イスラエル文化",
    "description": "エルサレム、テルアビブ、イスラエルの遺産",
    "shabbat": {
      "title": "シャバットモード",
      "enableShabbatMode": "シャバットモードを有効化",
      "shabbatTimes": "シャバットの時間",
      "timesDescription": "キャンドル点灯とハヴダラの時間がここに表示されます",
      "aboutTitle": "シャバットモードについて",
      "aboutDescription": "有効にすると、シャバットモードはシャバットの時間中に通知を一時停止し、画面の明るさを下げ、簡略化されたインターフェースを有効にします。"
    },
    "judaism": {
      "holidaysAndTorah": "祝日とトーラー",
      "parashaOfTheWeek": "今週のパラシャ",
      "parashaDescription": "毎週のトーラー朗読と解説"
    },
    "morning": {
      "title": "朝の儀式",
      "description": "意思と感謝をもって一日を始めましょう",
      "dailyInspiration": "日々のインスピレーション",
      "dailyInspirationDescription": "朝のルーティンに合わせた厳選コンテンツ",
      "modehAni": "モデ・アニ",
      "modehAniDescription": "朝の感謝の祈り",
      "netilatYadayim": "ネティラット・ヤダイム",
      "netilatYadayimDescription": "儀式的な手洗い",
      "shacharit": "シャハリット",
      "shacharitDescription": "朝の祈りの礼拝"
    },
    "glossary": {
      "termDetail": "用語の詳細",
      "definition": "定義",
      "pronunciation": "発音",
      "examples": "例"
    },
    "jerusalem": {
      "title": "エルサレム"
    },
    "telaviv": {
      "title": "テルアビブ"
    }
  },
  "zehAni": {
    "dashboard": {
      "title": "ゼ・アニ",
      "biometricConsent": "生体認証の同意",
      "activeConsents": "{{count}} 件の有効な同意",
      "magicMirror": "マジックミラー",
      "magicMirrorDescription": "毎日の挨拶とFace ID",
      "v2vPractice": "V2V練習",
      "v2vPracticeDescription": "音声対音声の発音",
      "avatar3d": "3Dアバター",
      "avatar3dDescription": "あなたのパーソナライズされたアバターメッシュ",
      "movieInteractions": "映画インタラクション",
      "movieInteractionsDescription": "映画のキャラクターを閲覧して会話する",
      "contacts": "連絡先",
      "contactsDescription": "WhatsApp連絡先の共有",
      "feedback": "フィードバック",
      "feedbackDescription": "体験を共有する",
      "consent": "同意",
      "consentDescription": "生体認証同意の管理",
      "chess": "チェス",
      "chessDescription": "友人や家族とチェスを楽しむ"
    },
    "mirror": {
      "title": "マジックミラー",
      "avatarContentDescription": "アバター",
      "wordOfTheDay": "今日の単語",
      "playLipsync": "リップシンクを再生",
      "noAvatarYet": "まだアバターがありません",
      "noAvatarDescription": "ストーリーに自分を登場させる3Dアバターを作成",
      "createAvatar": "アバターを作成"
    },
    "mode": {
      "title": "アバターモード",
      "enableAvatarMode": "アバターモードを有効化",
      "enableDescription": "コンテンツに反応するアバターを表示",
      "avatarPreview": "アバタープレビュー",
      "avatarPreviewContentDescription": "アバタープレビュー",
      "noAvatarConfigured": "アバターが設定されていません",
      "reactionStyle": "リアクションスタイル"
    },
    "wardrobe": {
      "title": "ワードローブ",
      "equippedContentDescription": "装備済み"
    },
    "settings": {
      "title": "アバター設定",
      "privacy": "プライバシー",
      "privateAvatarMode": "プライベートアバターモード",
      "privateAvatarDescription": "他のユーザーからアバターを非表示にする",
      "appearance": "外観",
      "enableAnimations": "アニメーションを有効化",
      "animationsDescription": "アバターの動きと表情をアニメーション化",
      "availableOutfits": "利用可能な衣装"
    },
    "selfie": {
      "title": "ビデオセルフィー",
      "camera": "カメラ",
      "cameraPreview": "カメラプレビュー",
      "startRecording": "録画を開始",
      "stopRecording": "録画を停止",
      "rec": "REC",
      "enterPin": "アバターを作成するにはPINを入力してください",
      "pinLabel": "PIN",
      "retake": "撮り直し",
      "creatingAvatar": "アバターを作成中...",
      "avatarCreated": "アバターが正常に作成されました",
      "avatarPreviewContentDescription": "アバタープレビュー",
      "createAnother": "もう一つ作成"
    },
    "mesh": {
      "title": "3Dアバター",
      "meshViewer": "3Dメッシュビューア",
      "meshViewerDescription": "3DメッシュビューアにはWebViewまたはGLSurfaceViewの統合が必要です",
      "skinTone": "肌の色",
      "hairStyle": "ヘアスタイル",
      "accessories": "アクセサリー",
      "saveChanges": "変更を保存"
    },
    "v2v": {
      "title": "ボイス練習",
      "nextPhrase": "次のフレーズ",
      "stop": "停止",
      "record": "録画",
      "mic": "MIC",
      "viewProgress": "進捗を表示",
      "analyzingPronunciation": "発音を分析中...",
      "pronunciationFeedback": "発音フィードバック",
      "similarity": "類似度: {{score}}%",
      "yourProgress": "あなたの進捗",
      "transforms": "変換: {{count}}",
      "improvement": "改善: {{score}}%",
      "continuePracticing": "練習を続ける"
    },
    "characters": {
      "title": "キャラクター",
      "noCharactersFound": "この映画のキャラクターが見つかりません",
      "characterCount": "{{count}} キャラクター"
    },
    "interactions": {
      "title": "映画インタラクション",
      "noInteractableMovies": "インタラクティブな映画はありません"
    },
    "feedbackInbox": {
      "title": "フィードバック受信箱",
      "refreshContentDescription": "更新",
      "noFeedbackYet": "まだフィードバックがありません",
      "feedbackAppearHere": "連絡先からのフィードバックがここに表示されます",
      "playVoiceMessage": "ボイスメッセージを再生"
    },
    "addContact": {
      "title": "連絡先を追加",
      "nameLabel": "名前",
      "phoneLabel": "電話",
      "relationship": "関係",
      "language": "言語"
    },
    "avatar3d": {
      "title": "3Dアバター",
      "glbMeshViewer": "GLBメッシュビューア",
      "controls": "コントロール",
      "animate": "アニメーション",
      "vertices": "頂点",
      "bones": "ボーン",
      "blendShapes": "ブレンドシェイプ",
      "hasGlb": "GLBあり",
      "status": "ステータス: {{value}}"
    }
  }
}
